import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_array } from "@swc/helpers/_/_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import { Alert, Card, CardBody, Container, Nav, Row, Col, Modal, Button, ButtonGroup, Form, Badge, Spinner, Table, Image, Stack } from "react-bootstrap";
import IconButton from "@mui/material/IconButton";
import Select from "react-select";
import { Formik } from "formik";
import { ModalAllder } from "layouts/ModalAllder";
import { TagsInput } from "react-tag-input-component";
import DownloadExcel from "utils/DownloadExcel";
import DataTableLayout from "layouts/DatatableLayout";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import { initState } from "mocks/poData";
import moment from "moment";
import "moment/locale/th";
import { DndContext, closestCenter } from "@dnd-kit/core";
import { getDiscountValue, NumberFormat, WDA, getPrefixName, filterTextAndNum, getInfoAdminSystem } from "utils/HelperFunction";
import { arrayMove, SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import ColumnResizer from "react-table-column-resizer";
import { nanoid } from "nanoid";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useSortable } from "@dnd-kit/sortable";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import CurrencyInput from "react-currency-input-field";
import { CSS } from "@dnd-kit/utilities";
import DeleteIcon from "@mui/icons-material/Delete";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import InfoIcon from "@mui/icons-material/Info";
import StackMui from "@mui/material/Stack";
import ButtonMui from "@mui/material/Button";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { getDataRsreserveById, clearGetDataRsreserveById } from "../../redux/handlers/reservation/getDataRsreserveById.handler";
import { getDataCatalogById, clearGetDataCatalogById } from "../../redux/handlers/reservation/getDataCatalogById.handler";
import { updateRsreserve, clearUpdateRsreserve } from "../../redux/handlers/reservation/updateRsreserve.handler";
import { deleteRsreserve, clearDeleteRsreserve } from "../../redux/handlers/reservation/deleteRsreserve.handler";
import { getDataAllCatalog, clearGetDataAllCatalog } from "../../redux/handlers/reservation/getDataAllCatalog.handler";
import { createRsreserve, clearCreateRsreserve } from "../../redux/handlers/reservation/createRsreserve.handler";
import { getAllMstTypeProduct, clearGetAllMstTypeProduct } from "../../redux/handlers/setting/getAllMstTypeProduct.handler";
import { getProductType } from "../../redux/handlers/product/getProductType.handler";
import { getCategory } from "../../redux/handlers/product/getCategory.handler";
import { getSubCategory } from "../../redux/handlers/product/getSubCategory.handler";
import { getMstBrandCate } from "../../redux/handlers/master/getMstBrandCate.handler";
import { getCatalogSummary } from "../../redux/handlers/master/getCatalogSummary.handler";
import { updateRsreserveStock, clearupdateRsreserveStock } from "../../redux/handlers/reservation/updateRsreserveStock.handler";
import ModalSuccessCustom from "layouts/ModalSuccessCustom";
import { use } from "react";
import { productCheckApi } from "services/productCheck.service";
var statusContactShow = [
    "ไม่ระบุ",
    "รอติดต่อ",
    "ยืนยันแล้ว",
    "ยกเลิก",
    "รีสถานะ"
];
var statusListShow = [
    "ไม่ระบุ",
    "รอยืนยัน",
    "ยืนยันแล้ว",
    "ยกเลิก",
    "รีสถานะ"
];
var isComplimentaryReserveCatalog = function(catalog) {
    return Number(catalog === null || catalog === void 0 ? void 0 : catalog.rs_catalog_free) === 2 || Number(catalog === null || catalog === void 0 ? void 0 : catalog.rs_catalog_tester) === 2;
};
var optionsStatusContact = [
    {
        value: 1,
        label: "รอติดต่อ"
    },
    {
        value: 2,
        label: "ยืนยันแล้ว"
    },
    {
        value: 3,
        label: "ยกเลิก"
    },
    {
        value: 4,
        label: "รีสถานะ"
    }
];
var optionsStatusList = [
    {
        value: 1,
        label: "รอยืนยัน"
    },
    {
        value: 2,
        label: "ยืนยันแล้ว"
    },
    {
        value: 3,
        label: "ยกเลิก"
    },
    {
        value: 4,
        label: "รีสถานะ"
    }
];
var normalizeQuantityInput = function(rawValue) {
    if (rawValue === "") return "";
    var digitsOnly = String(rawValue).replace(/\D/g, "");
    return digitsOnly.replace(/^0+(?=\d)/, "");
};
var normalizeDecimalInput = function(rawValue) {
    if (rawValue === "") return "";
    var sanitizedValue = String(rawValue).replace(/[^\d.]/g, "");
    var _sanitizedValue_split = _to_array(sanitizedValue.split(".")), tmp = _sanitizedValue_split[0], rawInteger = tmp === void 0 ? "" : tmp, decimalParts = _sanitizedValue_split.slice(1);
    var integerPart = rawInteger.replace(/^0+(?=\d)/, "") || "0";
    return decimalParts.length > 0 ? "".concat(integerPart, ".").concat(decimalParts.join("")) : integerPart;
};
export function ManageReservation() {
    var _reservationData_shBranch;
    var navigate = useNavigate();
    var location = useLocation();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useParams = useParams(), reportId = _useParams.reportId, typeShop = _useParams.typeShop;
    var reservationListPath = "/report/reservation".concat(location.search || "");
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("md"));
    var getDataRsreserveByIdReducer = useAppSelector(function(state) {
        return state.getDataRsreserveByIdReducer;
    });
    var getDataCatalogByIdReducer = useAppSelector(function(state) {
        return state.getDataCatalogByIdReducer;
    });
    var schema = yup.object().shape({});
    var _useState = _sliced_to_array(useState(false), 2), reloadCalMain = _useState[0], setReloadCalMain = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), bookId = _useState1[0], setBookId = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), catalogShow = _useState2[0], setCatalogShow = _useState2[1];
    var handleCatalogShow = function() {
        return setCatalogShow(true);
    };
    var handleCatalogClose = function() {
        return setCatalogShow(false);
    };
    var _useState3 = _sliced_to_array(useState(false), 2), saveDataShow = _useState3[0], setSaveDataShow = _useState3[1];
    var handleSaveDataShow = function() {
        return setSaveDataShow(true);
    };
    var handleSaveDataClose = function() {
        return setSaveDataShow(false);
    };
    var _useState4 = _sliced_to_array(useState(false), 2), deleteDataShow = _useState4[0], setDeleteDataShow = _useState4[1];
    var handleDeleteDataShow = function() {
        return setDeleteDataShow(true);
    };
    var handleDeleteDataClose = function() {
        return setDeleteDataShow(false);
    };
    var _useState5 = _sliced_to_array(useState({}), 2), reservationData = _useState5[0], setReservationData = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), dataItem = _useState6[0], setDataItem = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), detailSave = _useState7[0], setDetailSave = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), productData = _useState8[0], setProductData = _useState8[1];
    var _useState9 = _sliced_to_array(useState(null), 2), rsCatalogId = _useState9[0], setRsCatalogId = _useState9[1];
    var _useState10 = _sliced_to_array(useState(false), 2), reDataItem = _useState10[0], setReDataItem = _useState10[1];
    var handleDeletedCartItem = function(deletedCatalogId) {
        var deletedItem = dataItem.find(function(item) {
            return Number(item.rs_catalog_id) === Number(deletedCatalogId);
        });
        setDataItem(function(prev) {
            return prev.filter(function(item) {
                return Number(item.rs_catalog_id) !== Number(deletedCatalogId);
            });
        });
        if (deletedItem === null || deletedItem === void 0 ? void 0 : deletedItem.rs_catalog_clid) {
            setProductData(function(prev) {
                var deletedIndex = prev.findIndex(function(catalogId) {
                    return Number(catalogId) === Number(deletedItem.rs_catalog_clid);
                });
                return deletedIndex >= 0 ? prev.filter(function(_, index) {
                    return index !== deletedIndex;
                }) : prev;
            });
        }
        setRsCatalogId(null);
    };
    var _useState11 = _sliced_to_array(useState({
        visible: false,
        textsuccess: "",
        direction: ""
    }), 2), modalsuccess = _useState11[0], setModalsuccess = _useState11[1];
    var normalizeDetailQty = function(value) {
        return value !== null && value !== undefined && value !== "" ? parseInt(value, 10) : 0;
    };
    var normalizeDetailMoney = function(value) {
        return value !== null && value !== undefined && value !== "" ? parseFloat(value) : 0;
    };
    var reserveStatus = Number(reservationData.rs_reserve_status);
    var adminInfo = getInfoAdminSystem(localStorage.getItem("accessToken"));
    var userRoleId = Number((adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userRoleId) || 0);
    var _reservationData_rs_reserve_salestatus;
    var saleStatus = Number((_reservationData_rs_reserve_salestatus = reservationData.rs_reserve_salestatus) !== null && _reservationData_rs_reserve_salestatus !== void 0 ? _reservationData_rs_reserve_salestatus : reservationData.re_reserve_salestatus);
    var canManagePendingCart = saleStatus === 1;
    var canEditAmount = canManagePendingCart || saleStatus === 2 && reserveStatus === 1;
    var canEditStockAmount = reserveStatus === 4 && userRoleId === 9;
    var canAddProduct = canManagePendingCart || canEditStockAmount;
    var isEditMode = canEditAmount || reserveStatus === 4;
    var getData = function() {
        if (reportId && reportId > 0) {
            dispatch(getDataRsreserveById({
                rsreserveid: parseInt(reportId, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(getDataCatalogById({
                rsreserveid: parseInt(reportId, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    useEffect(function() {
        setIsLoading(getDataRsreserveByIdReducer.isFetching || getDataCatalogByIdReducer.isFetching);
        if (getDataRsreserveByIdReducer.data && !getDataRsreserveByIdReducer.isError) {
            var datas = getDataRsreserveByIdReducer.data.data;
            if (!datas) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements = Object.entries(datas).reduce(function(acc, param) {
                var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                acc[key] = value === null ? "" : value;
                return acc;
            }, {});
            if (dataWithReplacements && dataWithReplacements[0]) {
                setReservationData(dataWithReplacements[0]);
            } else if (dataWithReplacements) {
                setReservationData(dataWithReplacements);
            }
        }
        if (getDataCatalogByIdReducer.data && !getDataCatalogByIdReducer.isError) {
            var datas2 = getDataCatalogByIdReducer.data.data;
            if (!datas2) {
                return navigate("/404", {
                    replace: true
                });
            }
            setDataItem(datas2);
            setProductData(datas2.map(function(item) {
                return item.rs_catalog_clid;
            }));
        }
    }, [
        getDataRsreserveByIdReducer,
        getDataCatalogByIdReducer
    ]);
    useEffect(function() {
        getData();
    }, []);
    useEffect(function() {
        if (dataItem && dataItem.length > 0) {
            setDetailSave([]);
            dataItem.map(function(item) {
                if (item.rsDetail && item.rsDetail.length > 0) {
                    item.rsDetail.map(function(ditem) {
                        if (ditem.rs_detail_id && ditem.rs_detail_id > 0) {
                            setDetailSave(function(prev) {
                                return _to_consumable_array(prev).concat([
                                    {
                                        rs_detail_id: ditem.rs_detail_id,
                                        rs_detail_amount: normalizeDetailQty(ditem.rs_detail_amount),
                                        rs_detail_stamount: normalizeDetailQty(ditem.rs_detail_stamount),
                                        rs_detail_wholesale: normalizeDetailMoney(ditem.rs_detail_wholesale),
                                        rs_catalog_free: Number(item.rs_catalog_free) === 2 ? 2 : 1,
                                        rs_catalog_tester: Number(item.rs_catalog_tester) === 2 ? 2 : 1,
                                        rs_catalog_remark: item.rs_catalog_remark || ""
                                    }
                                ]);
                            });
                        }
                    });
                }
            });
        }
        if (reDataItem) {
            if (reportId && reportId > 0) {
                dispatch(getDataCatalogById({
                    rsreserveid: parseInt(reportId, 10)
                }, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
            setReDataItem(false);
        }
    }, [
        dataItem,
        reDataItem
    ]);
    var _reservationData_rs_reserve_salestatus1, _reservationData_rs_reserve_salestatus2, _reservationData_rs_reserve_salestatus3;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: reservationListPath,
                                        className: "tc-7  text-decoration-none",
                                        children: "รายงานการจอง"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "ตะกร้าสินค้า"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "d-flex gap-3 mb-3",
                        style: {
                            flexDirection: isMobile ? "column" : "row",
                            alignItems: isMobile ? "stretch" : "center"
                        },
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "fs-20",
                                style: {
                                    lineHeight: 1.35
                                },
                                children: [
                                    "ตะกร้าสินค้า",
                                    " ",
                                    /*#__PURE__*/ _jsxs("span", {
                                        style: {
                                            color: "#0d6efd"
                                        },
                                        children: [
                                            "รหัสใบจอง: ",
                                            reservationData.rs_reserve_code || "-"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: isMobile ? "" : "ms-auto",
                                children: /*#__PURE__*/ _jsx(Button, {
                                    variant: "outline-success",
                                    className: isMobile ? "w-100" : "",
                                    onClick: function() {
                                        setReloadCalMain(true);
                                        handleCatalogShow();
                                    },
                                    disabled: !canAddProduct,
                                    children: "เพิ่มสินค้า"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "",
                children: [
                    /*#__PURE__*/ _jsx(DetailItemSelect, {
                        dataItem: dataItem,
                        setDataItem: setDataItem,
                        reserveData: reservationData,
                        setReserveData: setReservationData,
                        mods: isEditMode ? "edit" : "views",
                        reserveStatus: reservationData.rs_reserve_status,
                        saleStatus: (_reservationData_rs_reserve_salestatus1 = reservationData.rs_reserve_salestatus) !== null && _reservationData_rs_reserve_salestatus1 !== void 0 ? _reservationData_rs_reserve_salestatus1 : reservationData.re_reserve_salestatus,
                        branchVatCal: ((_reservationData_shBranch = reservationData.shBranch) === null || _reservationData_shBranch === void 0 ? void 0 : _reservationData_shBranch.sh_branch_vatcal) || 1,
                        rsCatalogId: rsCatalogId,
                        setRsCatalogId: setRsCatalogId,
                        delDataOpen: handleDeleteDataShow
                    }),
                    /*#__PURE__*/ _jsx(DetailReservation, {
                        dataInfo: reservationData,
                        setDataInfo: setReservationData,
                        mods: isEditMode ? "edit" : "views",
                        isDisabled: true,
                        reserveStatus: reservationData.rs_reserve_status,
                        saleStatus: (_reservationData_rs_reserve_salestatus2 = reservationData.rs_reserve_salestatus) !== null && _reservationData_rs_reserve_salestatus2 !== void 0 ? _reservationData_rs_reserve_salestatus2 : reservationData.re_reserve_salestatus,
                        saveDataOpen: handleSaveDataShow,
                        reservationListPath: reservationListPath
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ProductModal, {
                show: catalogShow,
                onHide: handleCatalogClose,
                productData: productData,
                setProductData: setProductData,
                bookId: reservationData.all_catalog_book_id && reservationData.all_catalog_book_id > 0 ? parseInt(reservationData.all_catalog_book_id, 10) : null,
                reloadCalMain: reloadCalMain,
                shopId: reservationData.rs_reserve_shid,
                branchId: reservationData.rs_reserve_shbranchid,
                setReloadCalMain: setReloadCalMain,
                reDataItem: function() {
                    return setReDataItem(true);
                }
            }),
            /*#__PURE__*/ _jsx(SaveDataModal, {
                show: saveDataShow,
                onHide: handleSaveDataClose,
                setDataFrom: setDetailSave,
                dataFrom: detailSave,
                reserveStatus: reservationData.rs_reserve_status,
                saleStatus: (_reservationData_rs_reserve_salestatus3 = reservationData.rs_reserve_salestatus) !== null && _reservationData_rs_reserve_salestatus3 !== void 0 ? _reservationData_rs_reserve_salestatus3 : reservationData.re_reserve_salestatus,
                reserveData: reservationData,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                reservationListPath: reservationListPath
            }),
            /*#__PURE__*/ _jsx(DeleteDataModal, {
                show: deleteDataShow,
                onHide: handleDeleteDataClose,
                rsCatalogId: rsCatalogId,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                onDeleted: handleDeletedCartItem
            }),
            /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: modalsuccess.visible,
                onHide: function() {
                    return setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: false
                        });
                    });
                },
                textsuccess: modalsuccess.textsuccess,
                navigate: navigate,
                direction: modalsuccess.direction
            })
        ]
    });
}
export function ViewReservation() {
    var _reservationData_shBranch;
    var navigate = useNavigate();
    var location = useLocation();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var reportId = useParams().reportId;
    var reservationListPath = "/report/reservation".concat(location.search || "");
    var _useState = _sliced_to_array(useState({}), 2), reservationData = _useState[0], setReservationData = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), rsCatalogId = _useState1[0], setRsCatalogId = _useState1[1];
    var getDataRsreserveByIdReducer = useAppSelector(function(state) {
        return state.getDataRsreserveByIdReducer;
    });
    var getDataCatalogByIdReducer = useAppSelector(function(state) {
        return state.getDataCatalogByIdReducer;
    });
    var schema = yup.object().shape({});
    var _useState2 = _sliced_to_array(useState(false), 2), reloadCalMain = _useState2[0], setReloadCalMain = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), dataItem = _useState3[0], setDataItem = _useState3[1];
    var getData = function() {
        if (reportId && reportId > 0) {
            dispatch(getDataRsreserveById({
                rsreserveid: parseInt(reportId, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(getDataCatalogById({
                rsreserveid: parseInt(reportId, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    useEffect(function() {
        setIsLoading(getDataRsreserveByIdReducer.isFetching || getDataCatalogByIdReducer.isFetching);
        if (getDataRsreserveByIdReducer.data && !getDataRsreserveByIdReducer.isError) {
            var datas = getDataRsreserveByIdReducer.data.data;
            if (!datas) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements = Object.entries(datas).reduce(function(acc, param) {
                var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                acc[key] = value === null ? "" : value;
                return acc;
            }, {});
            if (dataWithReplacements && dataWithReplacements[0]) {
                setReservationData(dataWithReplacements[0]);
            } else if (dataWithReplacements) {
                setReservationData(dataWithReplacements);
            }
        }
        if (getDataCatalogByIdReducer.data && !getDataCatalogByIdReducer.isError) {
            var datas2 = getDataCatalogByIdReducer.data.data;
            if (!datas2) {
                return navigate("/404", {
                    replace: true
                });
            }
            setDataItem(datas2);
        }
    }, [
        getDataRsreserveByIdReducer,
        getDataCatalogByIdReducer
    ]);
    useEffect(function() {
        getData();
    }, []);
    var _reservationData_rs_reserve_salestatus, _reservationData_rs_reserve_salestatus1;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: reservationListPath,
                                        className: "tc-7  text-decoration-none",
                                        children: "รายงานการจอง"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายละเอียดการจอง"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Stack, {
                        direction: "horizontal",
                        gap: 3,
                        className: "mb-2",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "fs-24",
                            children: [
                                "รายละเอียดการจอง",
                                reservationData.rs_reserve_code && /*#__PURE__*/ _jsx("span", {
                                    className: "ms-2 fw-bold",
                                    children: reservationData.rs_reserve_code
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "",
                children: [
                    /*#__PURE__*/ _jsx(DetailItemSelect, {
                        dataItem: dataItem,
                        setDataItem: setDataItem,
                        reserveData: reservationData,
                        setReserveData: setReservationData,
                        mods: "views",
                        reserveStatus: reservationData.rs_reserve_status,
                        saleStatus: (_reservationData_rs_reserve_salestatus = reservationData.rs_reserve_salestatus) !== null && _reservationData_rs_reserve_salestatus !== void 0 ? _reservationData_rs_reserve_salestatus : reservationData.re_reserve_salestatus,
                        branchVatCal: ((_reservationData_shBranch = reservationData.shBranch) === null || _reservationData_shBranch === void 0 ? void 0 : _reservationData_shBranch.sh_branch_vatcal) || 1,
                        rsCatalogId: rsCatalogId,
                        setRsCatalogId: setRsCatalogId
                    }),
                    /*#__PURE__*/ _jsx(DetailReservation, {
                        dataInfo: reservationData,
                        setDataInfo: setReservationData,
                        mods: "views",
                        isDisabled: true,
                        reserveStatus: reservationData.rs_reserve_status,
                        saleStatus: (_reservationData_rs_reserve_salestatus1 = reservationData.rs_reserve_salestatus) !== null && _reservationData_rs_reserve_salestatus1 !== void 0 ? _reservationData_rs_reserve_salestatus1 : reservationData.re_reserve_salestatus,
                        saveDataOpen: function() {}
                    })
                ]
            })
        ]
    });
}
function DetailItemSelect(_param) {
    var dataItem = _param.dataItem, setDataItem = _param.setDataItem, props = _object_without_properties(_param, [
        "dataItem",
        "setDataItem"
    ]);
    var _props_reserveData, _props_reserveData1, _props_reserveData2, _props_reserveData3, _props_reserveData4, _props_reserveData5;
    var rest = _extends({}, _object_destructuring_empty(props));
    var isDisabled = props.mods && props.mods === "views" ? true : false;
    var reserveStatus = Number(props.reserveStatus);
    var saleStatus = Number(props.saleStatus);
    var adminInfo = getInfoAdminSystem(localStorage.getItem("accessToken"));
    var userRoleId = Number((adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userRoleId) || 0);
    var branchVatCal = Number(props.branchVatCal || 1);
    var canManagePendingCart = !isDisabled && saleStatus === 1;
    var canEditAmount = !isDisabled && (canManagePendingCart || saleStatus === 2 && reserveStatus === 1);
    var canEditExVat = canManagePendingCart;
    var canEditStockAmount = !isDisabled && reserveStatus === 4 && userRoleId === 9;
    var canEditDiscount = !isDisabled && canManagePendingCart;
    var isCatalogActionDisabled = !canManagePendingCart;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("md"));
    // เปลี่ยนจำนวนสินค้า
    var handleQtyChange = function(pid, idx, value) {
        setDataItem(function(prev) {
            return prev.map(function(p) {
                return p.rs_catalog_id === pid ? _object_spread_props(_object_spread({}, p), {
                    rsDetail: p.rsDetail.map(function(b) {
                        return b.rs_detail_id === idx ? _object_spread_props(_object_spread({}, b), {
                            rs_detail_amount: value,
                            _isEdited: true,
                            _isAmountEdited: true
                        }) : b;
                    })
                }) : p;
            });
        });
    };
    var handleSTQtyChange = function(pid, idx, value) {
        setDataItem(function(prev) {
            return prev.map(function(p) {
                return p.rs_catalog_id === pid ? _object_spread_props(_object_spread({}, p), {
                    rsDetail: p.rsDetail.map(function(b) {
                        return b.rs_detail_id === idx ? _object_spread_props(_object_spread({}, b), {
                            rs_detail_stamount: value,
                            _isEdited: true,
                            _isStockAmountEdited: true
                        }) : b;
                    })
                }) : p;
            });
        });
    };
    var getStockAmountInputValue = function(detail) {
        if (!(detail === null || detail === void 0 ? void 0 : detail._isStockAmountEdited) && Number((detail === null || detail === void 0 ? void 0 : detail.rs_detail_stamount) || 0) === 0) {
            return "";
        }
        var _detail_rs_detail_stamount;
        return (_detail_rs_detail_stamount = detail === null || detail === void 0 ? void 0 : detail.rs_detail_stamount) !== null && _detail_rs_detail_stamount !== void 0 ? _detail_rs_detail_stamount : "";
    };
    var calculateDetailPricingFromExVat = function(detail, promotion, rawExVat) {
        var wholesale = rawExVat === "" || rawExVat === null || rawExVat === undefined ? 0 : Number(rawExVat) || 0;
        var pricing = {
            rs_detail_wholesale: rawExVat,
            rs_detail_wholesalevat: rawExVat === "" ? "" : +(wholesale * 1.1).toFixed(2),
            rs_detail_discount: 0,
            rs_detail_wholesaledis: 0,
            rs_detail_wholesalevatdis: 0,
            rs_detail_wholesaleavg: 0
        };
        if (!promotion || !wholesale) {
            return pricing;
        }
        var promotionUnitId = Number(promotion.set_promotion_unitid);
        var detailUnitId = Number(detail.rs_detail_unitid);
        var promotionDiscount = Number(promotion.set_promotion_discount) || 0;
        var isPromotionUnitMatched = promotionUnitId === 6 && detailUnitId === 6 || promotionUnitId === 7 && detailUnitId === 7 || promotionUnitId === 4 && (detailUnitId === 4 || detailUnitId === 7);
        if ((promotion.set_promotion_type === 1 || promotion.set_promotion_type === 2) && isPromotionUnitMatched) {
            pricing.rs_detail_discount = promotionDiscount;
            pricing.rs_detail_wholesaledis = promotion.set_promotion_type === 1 ? wholesale - promotionDiscount : wholesale - wholesale * promotionDiscount / 100;
            pricing.rs_detail_wholesalevatdis = +(pricing.rs_detail_wholesaledis * 1.1).toFixed(2);
        } else if (promotion.set_promotion_type === 3 && detailUnitId === 4) {
            var promotionBuy = Number(promotion.set_promotion_buy) || 0;
            var promotionFree = Number(promotion.set_promotion_free) || 0;
            var totalFree = promotionBuy + promotionFree;
            if (totalFree > 0) {
                pricing.rs_detail_wholesaleavg = +(wholesale * promotionBuy / totalFree).toFixed(2);
            }
        }
        return pricing;
    };
    var handleExVatChange = function(pid, idx, rawValue) {
        var normalizedValue = normalizeDecimalInput(rawValue);
        setDataItem(function(prev) {
            return prev.map(function(p) {
                return p.rs_catalog_id === pid ? _object_spread_props(_object_spread({}, p), {
                    rsDetail: p.rsDetail.map(function(b) {
                        return b.rs_detail_id === idx ? _object_spread_props(_object_spread({}, b, calculateDetailPricingFromExVat(b, p.setPromotion, normalizedValue)), {
                            _isEdited: true
                        }) : b;
                    })
                }) : p;
            });
        });
    };
    var handleCatalogMetaChange = function(pid, patch) {
        var exclusivePatch = _object_spread({}, patch, Number(patch.rs_catalog_free) === 2 && {
            rs_catalog_tester: 1
        }, Number(patch.rs_catalog_tester) === 2 && {
            rs_catalog_free: 1
        });
        setDataItem(function(prev) {
            return prev.map(function(p) {
                return p.rs_catalog_id === pid ? _object_spread_props(_object_spread({}, p, exclusivePatch), {
                    rsDetail: p.rsDetail.map(function(b) {
                        return _object_spread_props(_object_spread({}, b), {
                            _isEdited: true
                        });
                    })
                }) : p;
            });
        });
    };
    var handleNonNegativeQtyInput = function(pid, idx, rawValue, onChangeValue) {
        if (rawValue === "") {
            onChangeValue(pid, idx, rawValue);
            return;
        }
        onChangeValue(pid, idx, normalizeQuantityInput(rawValue));
    };
    var getCartPriceTotal = function(items) {
        return (items || []).reduce(function(total, catalog) {
            return total + (catalog.rsDetail || []).reduce(function(detailTotal, detail) {
                return detailTotal + getDetailTotal(detail, catalog);
            }, 0);
        }, 0);
    };
    var normalizeDiscountType = function(value) {
        if (value === 0 || value === "0") return 0;
        return Number(value) === 2 ? 2 : 1;
    };
    var getDiscountSummary = function(price) {
        var _props_reserveData, _props_reserveData1;
        var discountType = normalizeDiscountType((_props_reserveData = props.reserveData) === null || _props_reserveData === void 0 ? void 0 : _props_reserveData.rs_reserve_discounttype);
        var discount = discountType === 0 ? 0 : Math.max(Number((_props_reserveData1 = props.reserveData) === null || _props_reserveData1 === void 0 ? void 0 : _props_reserveData1.rs_reserve_discount) || 0, 0);
        var rawDiscountReal = discountType === 0 ? 0 : discountType === 2 ? (Number(price) || 0) * discount / 100 : discount;
        var roundedDiscountReal = Math.round((rawDiscountReal + Number.EPSILON) * 100) / 100;
        var discountReal = Math.min(Math.max(roundedDiscountReal, 0), Number(price) || 0);
        return {
            price: Number(price) || 0,
            discountType: discountType,
            discount: discount,
            discountReal: discountReal,
            net: (Number(price) || 0) - discountReal
        };
    };
    var normalizeDiscountInput = function(value) {
        var rawValue = String(value !== null && value !== void 0 ? value : "").trim();
        if (rawValue === "") return "";
        if (!/^\d*\.?\d*$/.test(rawValue)) return null;
        var _rawValue_split = _sliced_to_array(rawValue.split("."), 2), tmp = _rawValue_split[0], integerPart = tmp === void 0 ? "" : tmp, decimalPart = _rawValue_split[1];
        var normalizedInteger = integerPart.replace(/^0+(?=\d)/, "") || (decimalPart !== undefined ? "0" : "0");
        return decimalPart !== undefined ? "".concat(normalizedInteger, ".").concat(decimalPart) : normalizedInteger;
    };
    var syncReserveDiscountSummary = function() {
        var patch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if (!props.setReserveData) return;
        props.setReserveData(function(prev) {
            var next = _object_spread({}, prev || {}, patch);
            var hasDiscountPatch = Object.prototype.hasOwnProperty.call(patch, "rs_reserve_discount");
            var discountInput = hasDiscountPatch ? normalizeDiscountInput(next.rs_reserve_discount) : next.rs_reserve_discount;
            if (discountInput === null) return prev;
            var price = getCartPriceTotal(dataItem);
            var discountType = normalizeDiscountType(next.rs_reserve_discounttype);
            var _next_rs_reserve_discount;
            var nextDiscountValue = discountType === 0 ? 0 : hasDiscountPatch ? discountInput : (_next_rs_reserve_discount = next.rs_reserve_discount) !== null && _next_rs_reserve_discount !== void 0 ? _next_rs_reserve_discount : discountInput;
            var discount = discountType === 0 ? 0 : Math.max(Number(discountInput) || 0, 0);
            var rawDiscountReal = discountType === 0 ? 0 : discountType === 2 ? price * discount / 100 : discount;
            var roundedDiscountReal = Math.round((rawDiscountReal + Number.EPSILON) * 100) / 100;
            var discountReal = Math.min(Math.max(roundedDiscountReal, 0), price);
            var net = price - discountReal;
            return _object_spread(_object_spread_props(_object_spread({}, next), {
                rs_reserve_discounttype: discountType,
                rs_reserve_discount: nextDiscountValue,
                rs_reserve_discountreal: discountReal
            }), reserveStatus === 4 ? {
                rs_reserve_stprice: price,
                rs_reserve_stnet: net
            } : {
                rs_reserve_price: price,
                rs_reserve_net: net
            });
        });
    };
    // ลบสินค้า
    var handleDelete = function(pid) {
        if (pid && pid > 0) {
            props.setRsCatalogId(pid);
            props.delDataOpen();
        }
    };
    var getDetailTotal = function(detail, catalog) {
        if (isComplimentaryReserveCatalog(catalog)) {
            return 0;
        }
        var rawQuantity = reserveStatus === 1 ? detail.rs_detail_amount : detail.rs_detail_stamount;
        var hasQuantityValue = rawQuantity !== null && rawQuantity !== undefined && rawQuantity !== "";
        var wasQuantityEdited = reserveStatus === 1 ? detail === null || detail === void 0 ? void 0 : detail._isAmountEdited : detail === null || detail === void 0 ? void 0 : detail._isStockAmountEdited;
        var quantity = hasQuantityValue ? Number(rawQuantity) || 0 : 0;
        if (hasQuantityValue || wasQuantityEdited) {
            if (branchVatCal === 1) {
                return (detail.rs_detail_wholesaledis > 0 ? detail.rs_detail_wholesaledis : detail.rs_detail_wholesale || 0) * quantity;
            }
            return (detail.rs_detail_wholesalevatdis > 0 ? detail.rs_detail_wholesalevatdis : detail.rs_detail_wholesalevat || 0) * quantity;
        }
        var dbNetField = reserveStatus === 4 ? "rs_detail_stnet" : "rs_detail_net";
        return (detail === null || detail === void 0 ? void 0 : detail[dbNetField]) ? parseFloat(detail[dbNetField]) : 0;
    };
    var subNetDataItem = function(dataItem) {
        return NumberFormat(getDiscountSummary(getCartPriceTotal(dataItem)).net, 2);
    };
    var cartPriceTotal = getCartPriceTotal(dataItem);
    var discountSummary = getDiscountSummary(cartPriceTotal);
    useEffect(function() {
        if (dataItem && dataItem.length > 0) {
            syncReserveDiscountSummary();
        }
    }, [
        dataItem,
        (_props_reserveData = props.reserveData) === null || _props_reserveData === void 0 ? void 0 : _props_reserveData.rs_reserve_discounttype,
        (_props_reserveData1 = props.reserveData) === null || _props_reserveData1 === void 0 ? void 0 : _props_reserveData1.rs_reserve_discount
    ]);
    var renderMobileProductCard = function(p, productIndex) {
        var _p_setPromotion;
        return /*#__PURE__*/ _jsx(Card, {
            className: "card-st-1 mb-3",
            style: {
                borderRadius: 8,
                border: "1px solid #e5e7eb",
                boxShadow: "0 1px 4px rgba(15, 23, 42, 0.08)"
            },
            children: /*#__PURE__*/ _jsxs(CardBody, {
                className: "p-1",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "d-flex align-items-start gap-1",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                style: {
                                    width: 88,
                                    flex: "0 0 88px"
                                },
                                children: p.rs_catalog_image && p.rs_catalog_image != "" && p.rs_catalog_image != null ? /*#__PURE__*/ _jsx(Image, {
                                    src: p.rs_catalog_image,
                                    alt: p.rs_catalog_name,
                                    style: {
                                        width: 88,
                                        height: 88,
                                        objectFit: "contain",
                                        border: "1px solid #e5e7eb",
                                        borderRadius: 8
                                    }
                                }) : /*#__PURE__*/ _jsx("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        border: "1px dashed #cbd5e1",
                                        borderRadius: 8,
                                        height: 88,
                                        width: 88,
                                        color: "#94a3b8",
                                        fontSize: 12
                                    },
                                    children: "ไม่มีรูป"
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                style: {
                                    minWidth: 0,
                                    flex: 1
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        style: {
                                            fontWeight: 700,
                                            color: "#111827",
                                            lineHeight: 1.35,
                                            wordBreak: "break-word"
                                        },
                                        children: p.rs_catalog_name || "-"
                                    }),
                                    p.rs_catalog_namela ? /*#__PURE__*/ _jsx("div", {
                                        style: {
                                            color: "#64748b",
                                            fontSize: 13,
                                            lineHeight: 1.35,
                                            marginTop: 2,
                                            wordBreak: "break-word"
                                        },
                                        children: p.rs_catalog_namela
                                    }) : null,
                                    ((_p_setPromotion = p.setPromotion) === null || _p_setPromotion === void 0 ? void 0 : _p_setPromotion.set_promotion_name) ? /*#__PURE__*/ _jsx(Badge, {
                                        bg: "danger",
                                        className: "mt-2",
                                        children: p.setPromotion.set_promotion_name
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ _jsx(IconButton, {
                                color: "error",
                                onClick: function() {
                                    return handleDelete(p.rs_catalog_id);
                                },
                                disabled: isCatalogActionDisabled,
                                "aria-label": "ลบสินค้า",
                                style: {
                                    marginTop: -6,
                                    marginRight: -8
                                },
                                children: /*#__PURE__*/ _jsx(DeleteIcon, {
                                    style: {
                                        borderRadius: "50%",
                                        color: isCatalogActionDisabled ? "#cbd5e1" : "#FF0000",
                                        border: "1px solid ".concat(isCatalogActionDisabled ? "#cbd5e1" : "#FF0000"),
                                        padding: 5,
                                        fontSize: 34
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mt-1",
                        children: [
                            /*#__PURE__*/ _jsx(Form.Check, {
                                type: "checkbox",
                                label: "ของแถม",
                                checked: Number(p.rs_catalog_free) === 2,
                                disabled: !canManagePendingCart,
                                onChange: function(e) {
                                    return handleCatalogMetaChange(p.rs_catalog_id, {
                                        rs_catalog_free: e.target.checked ? 2 : 1
                                    });
                                }
                            }),
                            /*#__PURE__*/ _jsx(Form.Check, {
                                type: "checkbox",
                                label: "สินค้าทดลอง",
                                checked: Number(p.rs_catalog_tester) === 2,
                                disabled: !canManagePendingCart,
                                onChange: function(e) {
                                    return handleCatalogMetaChange(p.rs_catalog_id, {
                                        rs_catalog_tester: e.target.checked ? 2 : 1
                                    });
                                }
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                as: "textarea",
                                rows: 2,
                                placeholder: "หมายเหตุ",
                                value: p.rs_catalog_remark || "",
                                disabled: !canManagePendingCart,
                                className: "mt-2",
                                onChange: function(e) {
                                    return handleCatalogMetaChange(p.rs_catalog_id, {
                                        rs_catalog_remark: e.target.value
                                    });
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "d-flex flex-column gap-2 mt-1",
                        children: (p.rsDetail || []).map(function(b, i) /*#__PURE__*/ {
                            var _b_set_unit_name, _b_rs_detail_ratio, _b_rs_detail_wholesale, _b_rs_detail_amount;
                            return _jsxs("div", {
                                style: {
                                    border: "1px solid #e5e7eb",
                                    borderRadius: 8,
                                    padding: 10,
                                    background: "#fff"
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "d-flex justify-content-between gap-2",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                style: {
                                                    minWidth: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        style: {
                                                            color: "#111827",
                                                            fontSize: 13
                                                        },
                                                        children: b.rs_detail_barcode || "-"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        style: {
                                                            color: "#64748b",
                                                            fontSize: 12
                                                        },
                                                        children: [
                                                            (_b_set_unit_name = b.set_unit_name) !== null && _b_set_unit_name !== void 0 ? _b_set_unit_name : "หน่วย",
                                                            " = ",
                                                            (_b_rs_detail_ratio = b.rs_detail_ratio) !== null && _b_rs_detail_ratio !== void 0 ? _b_rs_detail_ratio : 0,
                                                            " ชิ้น",
                                                            b.rs_detail_ratiooption && b.rs_detail_ratiooption > 0 ? " / ".concat(b.rs_detail_ratiooption, " แพ็ค") : ""
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                style: {
                                                    color: "#111827",
                                                    fontWeight: 700,
                                                    whiteSpace: "nowrap"
                                                },
                                                children: NumberFormat(getDetailTotal(b, p), 2)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Row, {
                                        className: "g-1",
                                        children: [
                                            /*#__PURE__*/ _jsxs(Col, {
                                                xs: 6,
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1 fs-12",
                                                        children: "Ex VAT"
                                                    }),
                                                    canEditExVat ? /*#__PURE__*/ _jsx(Form.Control, {
                                                        type: "text",
                                                        inputMode: "decimal",
                                                        pattern: "[0-9]*[.]?[0-9]*",
                                                        value: isComplimentaryReserveCatalog(p) ? 0 : (_b_rs_detail_wholesale = b.rs_detail_wholesale) !== null && _b_rs_detail_wholesale !== void 0 ? _b_rs_detail_wholesale : "",
                                                        style: {
                                                            textAlign: "right"
                                                        },
                                                        onChange: function(e) {
                                                            return handleExVatChange(p.rs_catalog_id, b.rs_detail_id, e.target.value);
                                                        },
                                                        disabled: isComplimentaryReserveCatalog(p)
                                                    }) : /*#__PURE__*/ _jsx("div", {
                                                        className: "form-control text-end bg-light",
                                                        children: NumberFormat(isComplimentaryReserveCatalog(p) ? 0 : b.rs_detail_wholesale || 0, 2)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Col, {
                                                xs: 6,
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1 fs-12",
                                                        children: "In VAT"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "form-control text-end bg-light",
                                                        children: NumberFormat(isComplimentaryReserveCatalog(p) ? 0 : b.rs_detail_wholesalevat || 0, 2)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Col, {
                                                xs: 6,
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1 fs-12",
                                                        children: "จำนวนสินค้า"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                        type: "text",
                                                        inputMode: "numeric",
                                                        pattern: "[0-9]*",
                                                        value: (_b_rs_detail_amount = b.rs_detail_amount) !== null && _b_rs_detail_amount !== void 0 ? _b_rs_detail_amount : "",
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        onChange: function(e) {
                                                            handleNonNegativeQtyInput(p.rs_catalog_id, b.rs_detail_id, e.target.value, handleQtyChange);
                                                        },
                                                        disabled: !canEditAmount,
                                                        readOnly: !canEditAmount
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Col, {
                                                xs: 6,
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1 fs-12",
                                                        children: "จำนวนส่งจริง"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                        type: "text",
                                                        inputMode: "numeric",
                                                        pattern: "[0-9]*",
                                                        value: getStockAmountInputValue(b),
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        onChange: function(e) {
                                                            handleNonNegativeQtyInput(p.rs_catalog_id, b.rs_detail_id, e.target.value, handleSTQtyChange);
                                                        },
                                                        disabled: !canEditStockAmount,
                                                        readOnly: !canEditStockAmount
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, b.rs_detail_id || i);
                        })
                    })
                ]
            })
        }, p.rs_catalog_id || productIndex);
    };
    var _props_reserveData_rs_reserve_discount, _props_reserveData_rs_reserve_discount1, _props_reserveData_rs_reserve_discount2, _props_reserveData_rs_reserve_discount3;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: isMobile ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                dataItem && dataItem.length ? dataItem.map(function(p, index) {
                    return renderMobileProductCard(p, index);
                }) : /*#__PURE__*/ _jsx(Card, {
                    className: "card-st-1 mb-4",
                    children: /*#__PURE__*/ _jsxs(CardBody, {
                        children: [
                            /*#__PURE__*/ _jsx(Row, {
                                className: "align-items-center",
                                children: /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    className: "text-center py-4",
                                    children: "ไม่พบข้อมูล"
                                })
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mt-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: "auto",
                                        className: "text-letf fs-18",
                                        children: "ราคาสุทธิก่อนหักส่วนลด"
                                    }),
                                    /*#__PURE__*/ _jsxs(Col, {
                                        xs: true,
                                        className: "text-right fs-18",
                                        children: [
                                            NumberFormat(discountSummary.price, 2),
                                            " บาท"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mt-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        className: "fs-18",
                                        children: "ส่วนลด"
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 5,
                                        children: /*#__PURE__*/ _jsxs(Form.Select, {
                                            value: discountSummary.discountType,
                                            disabled: !canEditDiscount,
                                            onChange: function(e) {
                                                return syncReserveDiscountSummary({
                                                    rs_reserve_discounttype: Number(e.target.value)
                                                });
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx("option", {
                                                    value: 0,
                                                    children: "ไม่ระบุ"
                                                }),
                                                /*#__PURE__*/ _jsx("option", {
                                                    value: 1,
                                                    children: "บาท"
                                                }),
                                                /*#__PURE__*/ _jsx("option", {
                                                    value: 2,
                                                    children: "เปอร์เซ็น"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 7,
                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                            type: "text",
                                            inputMode: "decimal",
                                            value: discountSummary.discountType === 0 ? 0 : (_props_reserveData_rs_reserve_discount = (_props_reserveData2 = props.reserveData) === null || _props_reserveData2 === void 0 ? void 0 : _props_reserveData2.rs_reserve_discount) !== null && _props_reserveData_rs_reserve_discount !== void 0 ? _props_reserveData_rs_reserve_discount : "",
                                            disabled: !canEditDiscount || discountSummary.discountType === 0,
                                            className: "text-end",
                                            onChange: function(e) {
                                                return syncReserveDiscountSummary({
                                                    rs_reserve_discount: e.target.value
                                                });
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mt-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: "auto",
                                        className: "text-letf fs-18",
                                        children: "จำนวนส่วนลดจริง"
                                    }),
                                    /*#__PURE__*/ _jsxs(Col, {
                                        xs: true,
                                        className: "text-right fs-18",
                                        children: [
                                            NumberFormat(discountSummary.discountReal, 2),
                                            " บาท"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mt-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: "auto",
                                        className: "text-letf fs-18",
                                        children: "ราคาสุทธิก่อนหักส่วนลด"
                                    }),
                                    /*#__PURE__*/ _jsxs(Col, {
                                        xs: true,
                                        className: "text-right fs-18",
                                        children: [
                                            NumberFormat(discountSummary.price, 2),
                                            " บาท"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mt-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        className: "fs-18",
                                        children: "ส่วนลด"
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 5,
                                        children: /*#__PURE__*/ _jsxs(Form.Select, {
                                            value: discountSummary.discountType,
                                            disabled: !canEditDiscount,
                                            onChange: function(e) {
                                                return syncReserveDiscountSummary({
                                                    rs_reserve_discounttype: Number(e.target.value)
                                                });
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx("option", {
                                                    value: 0,
                                                    children: "ไม่ระบุ"
                                                }),
                                                /*#__PURE__*/ _jsx("option", {
                                                    value: 1,
                                                    children: "บาท"
                                                }),
                                                /*#__PURE__*/ _jsx("option", {
                                                    value: 2,
                                                    children: "เปอร์เซ็น"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 7,
                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                            type: "text",
                                            inputMode: "decimal",
                                            value: discountSummary.discountType === 0 ? 0 : (_props_reserveData_rs_reserve_discount1 = (_props_reserveData3 = props.reserveData) === null || _props_reserveData3 === void 0 ? void 0 : _props_reserveData3.rs_reserve_discount) !== null && _props_reserveData_rs_reserve_discount1 !== void 0 ? _props_reserveData_rs_reserve_discount1 : "",
                                            disabled: !canEditDiscount || discountSummary.discountType === 0,
                                            className: "text-end",
                                            onChange: function(e) {
                                                return syncReserveDiscountSummary({
                                                    rs_reserve_discount: e.target.value
                                                });
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mt-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: "auto",
                                        className: "text-letf fs-18",
                                        children: "จำนวนส่วนลดจริง"
                                    }),
                                    /*#__PURE__*/ _jsxs(Col, {
                                        xs: true,
                                        className: "text-right fs-18",
                                        children: [
                                            NumberFormat(discountSummary.discountReal, 2),
                                            " บาท"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                dataItem && dataItem.length ? /*#__PURE__*/ _jsx(Card, {
                    className: "card-st-1 mb-4",
                    style: {
                        backgroundColor: "rgba(204, 204, 204,1)"
                    },
                    children: /*#__PURE__*/ _jsxs(CardBody, {
                        children: [
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mt-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: "auto",
                                        className: "text-letf fs-18",
                                        children: "ราคาสุทธิก่อนหักส่วนลด"
                                    }),
                                    /*#__PURE__*/ _jsxs(Col, {
                                        xs: true,
                                        className: "text-right fs-18",
                                        children: [
                                            NumberFormat(discountSummary.price, 2),
                                            " บาท"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mt-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        className: "fs-18",
                                        children: "ส่วนลด"
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 5,
                                        children: /*#__PURE__*/ _jsxs(Form.Select, {
                                            value: discountSummary.discountType,
                                            disabled: !canEditDiscount,
                                            onChange: function(e) {
                                                return syncReserveDiscountSummary({
                                                    rs_reserve_discounttype: Number(e.target.value)
                                                });
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx("option", {
                                                    value: 0,
                                                    children: "ไม่ระบุ"
                                                }),
                                                /*#__PURE__*/ _jsx("option", {
                                                    value: 1,
                                                    children: "บาท"
                                                }),
                                                /*#__PURE__*/ _jsx("option", {
                                                    value: 2,
                                                    children: "เปอร์เซ็น"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 7,
                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                            type: "text",
                                            inputMode: "decimal",
                                            value: discountSummary.discountType === 0 ? 0 : (_props_reserveData_rs_reserve_discount2 = (_props_reserveData4 = props.reserveData) === null || _props_reserveData4 === void 0 ? void 0 : _props_reserveData4.rs_reserve_discount) !== null && _props_reserveData_rs_reserve_discount2 !== void 0 ? _props_reserveData_rs_reserve_discount2 : "",
                                            disabled: !canEditDiscount || discountSummary.discountType === 0,
                                            className: "text-end",
                                            onChange: function(e) {
                                                return syncReserveDiscountSummary({
                                                    rs_reserve_discount: e.target.value
                                                });
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mt-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: "auto",
                                        className: "text-letf fs-18",
                                        children: "จำนวนส่วนลดจริง"
                                    }),
                                    /*#__PURE__*/ _jsxs(Col, {
                                        xs: true,
                                        className: "text-right fs-18",
                                        children: [
                                            NumberFormat(discountSummary.discountReal, 2),
                                            " บาท"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: "auto",
                                        className: "text-letf fs-18 fw-bold",
                                        children: "ยอดรวมสุทธิ"
                                    }),
                                    /*#__PURE__*/ _jsxs(Col, {
                                        xs: true,
                                        className: "text-right fs-18 fw-bold",
                                        children: [
                                            subNetDataItem(dataItem),
                                            " บาท"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }) : null
            ]
        }) : /*#__PURE__*/ _jsx("div", {
            className: "table-responsive",
            children: /*#__PURE__*/ _jsxs(Table, {
                striped: true,
                hover: true,
                className: "product-table-rstm",
                style: {
                    minWidth: 1440,
                    tableLayout: "fixed"
                },
                children: [
                    /*#__PURE__*/ _jsxs("thead", {
                        children: [
                            /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("th", {
                                        rowSpan: 2,
                                        className: "text-left align-middle p-2",
                                        style: {
                                            width: 780,
                                            maxWidth: 780
                                        },
                                        children: "รายการสินค้า"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        style: {
                                            width: "220px"
                                        },
                                        colSpan: 2,
                                        className: "text-center align-middle",
                                        children: "ราคาขายส่ง"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        style: {
                                            width: "120px"
                                        },
                                        className: "text-center align-middle p-2",
                                        rowSpan: 2,
                                        children: "จำนวนสินค้า"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        style: {
                                            width: "120px"
                                        },
                                        className: "text-center align-middle p-2",
                                        rowSpan: 2,
                                        children: "จำนวนส่งสินค้าจริง"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        style: {
                                            width: "140px"
                                        },
                                        className: "text-center align-middle p-2",
                                        rowSpan: 2,
                                        children: "ยอดรวม"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        style: {
                                            width: "60px"
                                        },
                                        className: "text-center align-middle p-2",
                                        rowSpan: 2,
                                        children: "ลบ"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "text-center align-middle p-2",
                                        style: {
                                            width: 170
                                        },
                                        children: "Ex Vat"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "text-center align-middle p-2",
                                        style: {
                                            width: 170
                                        },
                                        children: "In Vat"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("tbody", {
                        children: dataItem && dataItem.length ? dataItem.map(function(p) {
                            var _p_setPromotion;
                            return /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        style: {
                                            width: 780,
                                            minWidth: 780
                                        },
                                        children: /*#__PURE__*/ _jsxs(Row, {
                                            className: "align-items-start",
                                            style: {
                                                flexWrap: "nowrap"
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: "auto",
                                                    style: {
                                                        flex: "0 0 120px"
                                                    },
                                                    children: p.rs_catalog_image && p.rs_catalog_image != "" && p.rs_catalog_image != null ? /*#__PURE__*/ _jsx("div", {
                                                        style: {
                                                            alignContent: "start",
                                                            height: 100,
                                                            width: 100
                                                        },
                                                        children: /*#__PURE__*/ _jsx(Image, {
                                                            src: p.rs_catalog_image,
                                                            alt: p.rs_catalog_name,
                                                            style: {
                                                                maxWidth: 100,
                                                                maxHeight: 100
                                                            }
                                                        })
                                                    }) : /*#__PURE__*/ _jsx("div", {
                                                        style: {
                                                            alignContent: "center",
                                                            border: "1px dashed rgba(203, 208, 220, 1)",
                                                            borderRadius: 10,
                                                            height: 100,
                                                            width: 100
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    style: {
                                                        flex: "0 0 300px",
                                                        width: 300,
                                                        maxWidth: 300,
                                                        minWidth: 300,
                                                        overflow: "hidden"
                                                    },
                                                    children: /*#__PURE__*/ _jsxs(Row, {
                                                        className: "text-left",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Col, {
                                                                xs: 12,
                                                                style: {
                                                                    fontWeight: "bold",
                                                                    whiteSpace: "normal",
                                                                    overflowWrap: "break-word",
                                                                    wordBreak: "break-word",
                                                                    lineHeight: 1.35
                                                                },
                                                                title: p.rs_catalog_name,
                                                                children: p.rs_catalog_name
                                                            }),
                                                            /*#__PURE__*/ _jsx(Col, {
                                                                xs: 12,
                                                                style: {
                                                                    color: "#666",
                                                                    fontSize: 14,
                                                                    whiteSpace: "normal",
                                                                    overflowWrap: "break-word",
                                                                    wordBreak: "break-word",
                                                                    lineHeight: 1.35
                                                                },
                                                                title: p.rs_catalog_namela,
                                                                children: p.rs_catalog_namela
                                                            }),
                                                            ((_p_setPromotion = p.setPromotion) === null || _p_setPromotion === void 0 ? void 0 : _p_setPromotion.set_promotion_name) ? /*#__PURE__*/ _jsxs(Col, {
                                                                xs: 12,
                                                                style: {
                                                                    color: "#B00412",
                                                                    fontSize: 13
                                                                },
                                                                children: [
                                                                    "Promotion: ",
                                                                    p.setPromotion.set_promotion_name
                                                                ]
                                                            }) : null,
                                                            /*#__PURE__*/ _jsxs(Col, {
                                                                xs: 12,
                                                                className: "mt-2",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Check, {
                                                                        type: "checkbox",
                                                                        label: "ของแถม",
                                                                        checked: Number(p.rs_catalog_free) === 2,
                                                                        disabled: !canManagePendingCart,
                                                                        onChange: function(e) {
                                                                            return handleCatalogMetaChange(p.rs_catalog_id, {
                                                                                rs_catalog_free: e.target.checked ? 2 : 1
                                                                            });
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Check, {
                                                                        type: "checkbox",
                                                                        label: "สินค้าทดลอง",
                                                                        checked: Number(p.rs_catalog_tester) === 2,
                                                                        disabled: !canManagePendingCart,
                                                                        onChange: function(e) {
                                                                            return handleCatalogMetaChange(p.rs_catalog_id, {
                                                                                rs_catalog_tester: e.target.checked ? 2 : 1
                                                                            });
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        as: "textarea",
                                                                        rows: 2,
                                                                        placeholder: "หมายเหตุ",
                                                                        value: p.rs_catalog_remark || "",
                                                                        disabled: !canManagePendingCart,
                                                                        style: {
                                                                            width: 300,
                                                                            maxWidth: 300
                                                                        },
                                                                        onChange: function(e) {
                                                                            return handleCatalogMetaChange(p.rs_catalog_id, {
                                                                                rs_catalog_remark: e.target.value
                                                                            });
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    style: {
                                                        flex: "0 0 380px",
                                                        maxWidth: 380,
                                                        minWidth: 380
                                                    },
                                                    children: /*#__PURE__*/ _jsx(Row, {
                                                        children: p.rsDetail.map(function(b, i) /*#__PURE__*/ {
                                                            var _b_set_unit_name, _b_rs_detail_ratio, _b_rs_detail_ratiooption, _b_set_unit_name1, _b_rs_detail_ratio1;
                                                            return _jsxs(_Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Col, {
                                                                        xs: 6,
                                                                        className: "d-flex justify-content-start align-items-center fs-18",
                                                                        style: {
                                                                            height: 50
                                                                        },
                                                                        children: /*#__PURE__*/ _jsx("span", {
                                                                            style: {
                                                                                whiteSpace: "nowrap"
                                                                            },
                                                                            children: b.rs_detail_barcode
                                                                        })
                                                                    }, i),
                                                                    /*#__PURE__*/ _jsx(Col, {
                                                                        xs: 6,
                                                                        className: "d-flex justify-content-start align-items-center fs-18",
                                                                        style: {
                                                                            height: 50
                                                                        },
                                                                        children: b.rs_detail_ratiooption && b.rs_detail_ratiooption > 0 ? /*#__PURE__*/ _jsxs("span", {
                                                                            style: {
                                                                                color: "#666",
                                                                                whiteSpace: "nowrap"
                                                                            },
                                                                            children: [
                                                                                (_b_set_unit_name = b.set_unit_name) !== null && _b_set_unit_name !== void 0 ? _b_set_unit_name : "หน่วย",
                                                                                " =",
                                                                                " ",
                                                                                (_b_rs_detail_ratio = b.rs_detail_ratio) !== null && _b_rs_detail_ratio !== void 0 ? _b_rs_detail_ratio : 0,
                                                                                " ชิ้น /",
                                                                                " ",
                                                                                (_b_rs_detail_ratiooption = b.rs_detail_ratiooption) !== null && _b_rs_detail_ratiooption !== void 0 ? _b_rs_detail_ratiooption : 0,
                                                                                " แพ็ค"
                                                                            ]
                                                                        }) : /*#__PURE__*/ _jsxs("span", {
                                                                            style: {
                                                                                color: "#666",
                                                                                whiteSpace: "nowrap"
                                                                            },
                                                                            children: [
                                                                                (_b_set_unit_name1 = b.set_unit_name) !== null && _b_set_unit_name1 !== void 0 ? _b_set_unit_name1 : "หน่วย",
                                                                                " =",
                                                                                " ",
                                                                                (_b_rs_detail_ratio1 = b.rs_detail_ratio) !== null && _b_rs_detail_ratio1 !== void 0 ? _b_rs_detail_ratio1 : 0,
                                                                                " ชิ้น"
                                                                            ]
                                                                        })
                                                                    }, i)
                                                                ]
                                                            });
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "text-center align-middle",
                                        children: /*#__PURE__*/ _jsx(Row, {
                                            children: p.rsDetail.map(function(b, i) /*#__PURE__*/ {
                                                var _b_rs_detail_wholesale;
                                                return _jsx(Col, {
                                                    xs: 12,
                                                    className: "d-flex justify-content-end align-items-center fs-18",
                                                    style: {
                                                        height: 50
                                                    },
                                                    children: canEditExVat ? /*#__PURE__*/ _jsx(Form.Control, {
                                                        type: "text",
                                                        inputMode: "decimal",
                                                        pattern: "[0-9]*[.]?[0-9]*",
                                                        value: isComplimentaryReserveCatalog(p) ? 0 : (_b_rs_detail_wholesale = b.rs_detail_wholesale) !== null && _b_rs_detail_wholesale !== void 0 ? _b_rs_detail_wholesale : "",
                                                        style: {
                                                            width: 120,
                                                            textAlign: "right"
                                                        },
                                                        onChange: function(e) {
                                                            return handleExVatChange(p.rs_catalog_id, b.rs_detail_id, e.target.value);
                                                        },
                                                        disabled: isComplimentaryReserveCatalog(p)
                                                    }) : /*#__PURE__*/ _jsx("span", {
                                                        style: {
                                                            color: "#666"
                                                        },
                                                        children: NumberFormat(isComplimentaryReserveCatalog(p) ? 0 : b.rs_detail_wholesale ? b.rs_detail_wholesale : 0, 2)
                                                    })
                                                }, i);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "text-center align-middle",
                                        children: /*#__PURE__*/ _jsx(Row, {
                                            children: p.rsDetail.map(function(b, i) {
                                                return /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    className: "d-flex justify-content-end align-items-center fs-18",
                                                    style: {
                                                        height: 50
                                                    },
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        style: {
                                                            color: "#666"
                                                        },
                                                        children: NumberFormat(isComplimentaryReserveCatalog(p) ? 0 : b.rs_detail_wholesalevat ? b.rs_detail_wholesalevat : 0, 2)
                                                    })
                                                }, i);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "text-center align-middle",
                                        children: /*#__PURE__*/ _jsx(Row, {
                                            children: p.rsDetail.map(function(b, i) {
                                                return /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    className: "d-flex justify-content-center align-items-center",
                                                    style: {
                                                        height: 50
                                                    },
                                                    children: /*#__PURE__*/ _jsx(Form.Control, {
                                                        type: "text",
                                                        inputMode: "numeric",
                                                        pattern: "[0-9]*",
                                                        value: b.rs_detail_amount,
                                                        style: {
                                                            width: 100,
                                                            textAlign: "center"
                                                        },
                                                        onChange: function(e) {
                                                            handleNonNegativeQtyInput(p.rs_catalog_id, b.rs_detail_id, e.target.value, handleQtyChange);
                                                        },
                                                        disabled: !canEditAmount,
                                                        readOnly: !canEditAmount
                                                    })
                                                }, i);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "text-center align-middle",
                                        children: /*#__PURE__*/ _jsx(Row, {
                                            children: p.rsDetail.map(function(b, i) {
                                                return /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    className: "d-flex justify-content-center align-items-center",
                                                    style: {
                                                        height: 50
                                                    },
                                                    children: /*#__PURE__*/ _jsx(Form.Control, {
                                                        type: "text",
                                                        inputMode: "numeric",
                                                        pattern: "[0-9]*",
                                                        value: getStockAmountInputValue(b),
                                                        style: {
                                                            width: 100,
                                                            textAlign: "center"
                                                        },
                                                        onChange: function(e) {
                                                            handleNonNegativeQtyInput(p.rs_catalog_id, b.rs_detail_id, e.target.value, handleSTQtyChange);
                                                        },
                                                        disabled: !canEditStockAmount,
                                                        readOnly: !canEditStockAmount
                                                    })
                                                }, i);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "text-right align-middle",
                                        children: /*#__PURE__*/ _jsx(Row, {
                                            children: p.rsDetail.map(function(b, i) {
                                                return /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    className: "d-flex justify-content-end align-items-center fs-18",
                                                    style: {
                                                        height: 50
                                                    },
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        style: {
                                                            color: "#666"
                                                        },
                                                        children: NumberFormat(getDetailTotal(b, p), 2)
                                                    })
                                                }, i);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "text-center align-middle",
                                        children: /*#__PURE__*/ _jsx(IconButton, {
                                            color: "error",
                                            onClick: function() {
                                                handleDelete(p.rs_catalog_id);
                                            },
                                            disabled: isCatalogActionDisabled,
                                            children: /*#__PURE__*/ _jsx(DeleteIcon, {
                                                style: {
                                                    borderRadius: "50%",
                                                    color: "#FF0000",
                                                    border: "1px solid #FF0000",
                                                    padding: 5,
                                                    fontSize: 35
                                                }
                                            })
                                        })
                                    })
                                ]
                            }, p.rs_catalog_id);
                        }) : /*#__PURE__*/ _jsx("tr", {
                            children: /*#__PURE__*/ _jsx("td", {
                                colSpan: 6,
                                className: "text-center",
                                children: "ไม่พบข้อมูล"
                            })
                        })
                    }),
                    dataItem && dataItem.length && dataItem.length > 0 ? /*#__PURE__*/ _jsxs("tfoot", {
                        children: [
                            /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        colSpan: 5,
                                        className: "text-end fs-18",
                                        children: "ราคาสุทธิก่อนหักส่วนลด"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "text-end fs-18",
                                        children: NumberFormat(discountSummary.price, 2)
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "text-center fs-18",
                                        children: "บาท"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        colSpan: 6,
                                        className: "text-end fs-18",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "d-flex gap-2 justify-content-end align-items-center",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "text-end fs-18",
                                                    style: {
                                                        width: 60
                                                    },
                                                    children: "ส่วนลด"
                                                }),
                                                /*#__PURE__*/ _jsxs(Form.Select, {
                                                    value: discountSummary.discountType,
                                                    disabled: !canEditDiscount,
                                                    style: {
                                                        width: 120
                                                    },
                                                    onChange: function(e) {
                                                        return syncReserveDiscountSummary({
                                                            rs_reserve_discounttype: Number(e.target.value)
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("option", {
                                                            value: 0,
                                                            children: "ไม่ระบุ"
                                                        }),
                                                        /*#__PURE__*/ _jsx("option", {
                                                            value: 1,
                                                            children: "บาท"
                                                        }),
                                                        /*#__PURE__*/ _jsx("option", {
                                                            value: 2,
                                                            children: "เปอร์เซ็น"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    inputMode: "decimal",
                                                    value: discountSummary.discountType === 0 ? 0 : (_props_reserveData_rs_reserve_discount3 = (_props_reserveData5 = props.reserveData) === null || _props_reserveData5 === void 0 ? void 0 : _props_reserveData5.rs_reserve_discount) !== null && _props_reserveData_rs_reserve_discount3 !== void 0 ? _props_reserveData_rs_reserve_discount3 : "",
                                                    disabled: !canEditDiscount || discountSummary.discountType === 0,
                                                    className: "text-end",
                                                    style: {
                                                        width: 140
                                                    },
                                                    onChange: function(e) {
                                                        return syncReserveDiscountSummary({
                                                            rs_reserve_discount: e.target.value
                                                        });
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "text-center fs-18",
                                        children: discountSummary.discountType === 0 ? "-" : discountSummary.discountType === 2 ? "%" : "บาท"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        colSpan: 5,
                                        className: "text-end fs-18",
                                        children: "จำนวนส่วนลดจริง"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "text-end fs-18",
                                        children: NumberFormat(discountSummary.discountReal, 2)
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "text-center fs-18",
                                        children: "บาท"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        colSpan: 5,
                                        className: "text-end fs-18",
                                        style: {
                                            backgroundColor: "rgba(204, 204, 204,1)"
                                        },
                                        children: "ยอดรวมสุทธิ"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "text-end fs-18",
                                        style: {
                                            backgroundColor: "rgba(204, 204, 204,1)"
                                        },
                                        children: /*#__PURE__*/ _jsx("span", {
                                            children: subNetDataItem(dataItem)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "text-center fs-18",
                                        style: {
                                            backgroundColor: "rgba(204, 204, 204,1)"
                                        },
                                        children: /*#__PURE__*/ _jsx("span", {
                                            children: "บาท"
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : null
                ]
            })
        })
    });
}
function DetailReservation(_param) {
    var dataInfo = _param.dataInfo, setDataInfo = _param.setDataInfo, props = _object_without_properties(_param, [
        "dataInfo",
        "setDataInfo"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var reportId = useParams().reportId;
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var isDisabled = props.isDisabled ? true : false;
    var mods = props.mods && props.mods === "views" ? props.mods : "edit";
    var reserveStatus = Number(props.reserveStatus);
    var saleStatus = Number(props.saleStatus);
    var reservationListPath = props.reservationListPath || "/report/reservation";
    var showScheduleCard = reserveStatus !== 1;
    var canEditScheduleDates = mods === "edit" && reserveStatus === 4;
    var canEditReserveAmount = saleStatus === 1 || saleStatus === 2 && reserveStatus === 1;
    var canEditShippingPayType = mods === "edit" && canEditReserveAmount;
    var canSelectOriginShipping = Number(dataInfo === null || dataInfo === void 0 ? void 0 : dataInfo.sh_branch_shipping_paytype) === 1;
    var canEditRemark = mods === "edit" && saleStatus === 1;
    var paymentFiles = Array.isArray(dataInfo === null || dataInfo === void 0 ? void 0 : dataInfo.rsFile) ? dataInfo.rsFile : [];
    var showPaymentCard = reserveStatus === 6 || !!(dataInfo === null || dataInfo === void 0 ? void 0 : dataInfo.rs_reserve_paydate) || !!(dataInfo === null || dataInfo === void 0 ? void 0 : dataInfo.rs_reserve_invoicecode) || paymentFiles.length > 0;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("md"));
    var _useState = _sliced_to_array(useState([]), 2), optionsShop = _useState[0], setOptionsShop = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), nameShopShow = _useState1[0], setNameShopShow = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), shippingPayTypeError = _useState2[0], setShippingPayTypeError = _useState2[1];
    var shippingPayTypeOriginRef = useRef(null);
    var schema = yup.object().shape({});
    var validateScheduleDatesBeforeSave = function() {
        if (canEditShippingPayType && ![
            1,
            2
        ].includes(Number(dataInfo.rs_reserve_shipping_paytype))) {
            setShippingPayTypeError("กรุณาเลือกการชำระค่าขนส่ง");
            window.requestAnimationFrame(function() {
                var _shippingPayTypeOriginRef_current, _shippingPayTypeOriginRef_current1;
                (_shippingPayTypeOriginRef_current = shippingPayTypeOriginRef.current) === null || _shippingPayTypeOriginRef_current === void 0 ? void 0 : _shippingPayTypeOriginRef_current.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                (_shippingPayTypeOriginRef_current1 = shippingPayTypeOriginRef.current) === null || _shippingPayTypeOriginRef_current1 === void 0 ? void 0 : _shippingPayTypeOriginRef_current1.focus();
            });
            return false;
        }
        setShippingPayTypeError("");
        if (canEditScheduleDates && (!dataInfo.rs_reserve_dateorganize || !dataInfo.rs_reserve_datedelivery)) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 400",
                navigateDirection: undefined,
                title: "กรุณากรอก วันที่จัดสินค้า และ วันที่คาดว่าจะจัดส่งสินค้า"
            }));
            return false;
        }
        return true;
    };
    useEffect(function() {
        if (dataInfo && dataInfo.rs_reserve_id > 0) {
            if (dataInfo.rs_reserve_shid && dataInfo.rs_reserve_shid > 0) {
                var shopName = dataInfo.rs_reserve_shopname;
                if (dataInfo.rs_reserve_branchname && dataInfo.rs_reserve_branchname.trim() !== "") {
                    shopName += " : ".concat(dataInfo.rs_reserve_branchname.trim());
                } else {
                    shopName += " : สำนักงานใหญ่";
                }
                setOptionsShop(function(optionsShop) {
                    return _to_consumable_array(optionsShop).concat([
                        {
                            value: dataInfo.rs_reserve_shid,
                            branchId: dataInfo.rs_reserve_shbranchid,
                            label: shopName.trim()
                        }
                    ]);
                });
                setNameShopShow(shopName.trim());
            }
        }
    }, [
        dataInfo
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(Formik, {
            enableReinitialize: true,
            initialValues: dataInfo,
            validationSchema: schema,
            onSubmit: function() {
                var _ref = _async_to_generator(function(values) {
                    return _ts_generator(this, function(_state) {
                        return [
                            2
                        ];
                    });
                //await sleep(500);
                });
                return function(values) {
                    return _ref.apply(this, arguments);
                };
            }(),
            children: function(param) /*#__PURE__*/ {
                var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, setValues = param.setValues, isInvalid = param.isInvalid, isValid = param.isValid, resetForm = param.resetForm;
                var _values_rs_reserve_note, _values_rs_reserve_credit;
                return _jsxs(Form, {
                    noValidate: true,
                    onSubmit: handleSubmit,
                    children: [
                        showScheduleCard ? /*#__PURE__*/ _jsx(Card, {
                            className: "card-st-1 mb-1",
                            children: /*#__PURE__*/ _jsx(CardBody, {
                                children: /*#__PURE__*/ _jsxs(Row, {
                                    className: "align-items-center",
                                    children: [
                                        /*#__PURE__*/ _jsxs(Col, {
                                            xs: 12,
                                            md: 6,
                                            lg: 3,
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "fs-18 fw-bold mb-4",
                                                    children: "วันที่จัดสินค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Group, {
                                                    className: "mb-2 form-st-3",
                                                    children: /*#__PURE__*/ _jsx(DatePicker, {
                                                        inputFormat: "DD/MM/YYYY",
                                                        selected: values.rs_reserve_dateorganize ? moment(values.rs_reserve_dateorganize).toDate() : "",
                                                        onChange: function(date) {
                                                            var nextValue = moment(date).isValid() ? moment(date).format("YYYY-MM-DD 00:00:00") : "";
                                                            setFieldValue("rs_reserve_dateorganize", nextValue);
                                                            setDataInfo(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    rs_reserve_dateorganize: nextValue
                                                                });
                                                            });
                                                        },
                                                        placeholder: "DD/MM/YYYY",
                                                        className: "w-100 datepicker2",
                                                        value: values.rs_reserve_dateorganize ? moment(values.rs_reserve_dateorganize).format("DD/MM/YYYY") : "",
                                                        disabled: !canEditScheduleDates,
                                                        readOnly: !canEditScheduleDates
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(Col, {
                                            xs: 12,
                                            md: 6,
                                            lg: 3,
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "fs-18 fw-bold mb-4",
                                                    children: "วันที่คาดว่าจะจัดส่งสินค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Group, {
                                                    className: "mb-2 form-st-3",
                                                    children: /*#__PURE__*/ _jsx(DatePicker, {
                                                        inputFormat: "DD/MM/YYYY",
                                                        selected: values.rs_reserve_datedelivery ? moment(values.rs_reserve_datedelivery).toDate() : "",
                                                        onChange: function(date) {
                                                            var nextValue = moment(date).isValid() ? moment(date).format("YYYY-MM-DD 00:00:00") : "";
                                                            setFieldValue("rs_reserve_datedelivery", nextValue);
                                                            setDataInfo(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    rs_reserve_datedelivery: nextValue
                                                                });
                                                            });
                                                        },
                                                        placeholder: "DD/MM/YYYY",
                                                        className: "w-100 datepicker2",
                                                        value: values.rs_reserve_datedelivery ? moment(values.rs_reserve_datedelivery).format("DD/MM/YYYY") : "",
                                                        disabled: !canEditScheduleDates,
                                                        readOnly: !canEditScheduleDates
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }) : null,
                        showPaymentCard ? /*#__PURE__*/ _jsx(Card, {
                            className: "card-st-1 mb-1 border-0",
                            children: /*#__PURE__*/ _jsx(CardBody, {
                                children: /*#__PURE__*/ _jsxs(Row, {
                                    className: "align-items-start",
                                    children: [
                                        /*#__PURE__*/ _jsxs(Col, {
                                            xs: 12,
                                            md: 4,
                                            lg: 3,
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "fs-18 fw-bold mb-3",
                                                    children: "ข้อมูลชำระเงิน"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "small text-muted mb-1",
                                                    children: "วันที่ชำระเงิน"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "fw-semibold mb-3",
                                                    children: (dataInfo === null || dataInfo === void 0 ? void 0 : dataInfo.rs_reserve_paydate) ? moment(dataInfo.rs_reserve_paydate).format("DD/MM/YYYY") : "-"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "small text-muted mb-1",
                                                    children: "รหัสใบแจ้งหนี้"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "fw-semibold mb-3",
                                                    children: (dataInfo === null || dataInfo === void 0 ? void 0 : dataInfo.rs_reserve_invoicecode) || "-"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "small text-muted mb-1",
                                                    children: "ผู้รับชำระ"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "fw-semibold",
                                                    children: (dataInfo === null || dataInfo === void 0 ? void 0 : dataInfo.rs_reserve_payname) || "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(Col, {
                                            xs: 12,
                                            md: 8,
                                            lg: 9,
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "fs-16 fw-bold mb-3",
                                                    children: "หลักฐานชำระเงิน"
                                                }),
                                                paymentFiles.length > 0 ? /*#__PURE__*/ _jsx(Row, {
                                                    className: "g-3",
                                                    children: paymentFiles.map(function(file) {
                                                        return /*#__PURE__*/ _jsx(Col, {
                                                            xs: 6,
                                                            md: 4,
                                                            lg: 3,
                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                href: file.rs_file_url,
                                                                target: "_blank",
                                                                rel: "noreferrer",
                                                                className: "text-decoration-none",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "border rounded-3 overflow-hidden h-100 bg-light",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Image, {
                                                                            src: file.rs_file_url,
                                                                            alt: file.rs_file_name || "payment-file",
                                                                            fluid: true,
                                                                            style: {
                                                                                width: "100%",
                                                                                height: "170px",
                                                                                objectFit: "cover"
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "px-2 py-2 small text-dark text-truncate",
                                                                            children: file.rs_file_name || "ไฟล์แนบ"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }, file.rs_file_id);
                                                    })
                                                }) : /*#__PURE__*/ _jsx("div", {
                                                    className: "text-muted",
                                                    children: "ยังไม่มีไฟล์แนบ"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }) : null,
                        /*#__PURE__*/ _jsx(Card, {
                            className: "card-st-1 mb-1",
                            children: /*#__PURE__*/ _jsxs(CardBody, {
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-18 fw-bold mb-3",
                                        children: "การชำระค่าขนส่ง"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "d-flex flex-wrap gap-4",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                ref: shippingPayTypeOriginRef,
                                                type: "radio",
                                                id: "shipping-paytype-origin",
                                                name: "rs_reserve_shipping_paytype",
                                                label: "เก็บต้นทาง",
                                                value: 1,
                                                checked: Number(values.rs_reserve_shipping_paytype) === 1,
                                                disabled: !canEditShippingPayType || !canSelectOriginShipping,
                                                onChange: function() {
                                                    setShippingPayTypeError("");
                                                    setFieldValue("rs_reserve_shipping_paytype", 1);
                                                    setDataInfo(function(prev) {
                                                        return _object_spread_props(_object_spread({}, prev), {
                                                            rs_reserve_shipping_paytype: 1
                                                        });
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                type: "radio",
                                                id: "shipping-paytype-destination",
                                                name: "rs_reserve_shipping_paytype",
                                                label: "เก็บปลายทาง",
                                                value: 2,
                                                checked: Number(values.rs_reserve_shipping_paytype) === 2,
                                                disabled: !canEditShippingPayType,
                                                onChange: function() {
                                                    setShippingPayTypeError("");
                                                    setFieldValue("rs_reserve_shipping_paytype", 2);
                                                    setDataInfo(function(prev) {
                                                        return _object_spread_props(_object_spread({}, prev), {
                                                            rs_reserve_shipping_paytype: 2
                                                        });
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    shippingPayTypeError ? /*#__PURE__*/ _jsx("div", {
                                        className: "text-danger fs-14 mt-2",
                                        role: "alert",
                                        children: shippingPayTypeError
                                    }) : null
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("fieldset", {
                            disabled: isDisabled && !canEditRemark,
                            children: /*#__PURE__*/ _jsx(Card, {
                                className: "card-st-1 mb-1",
                                children: /*#__PURE__*/ _jsx(CardBody, {
                                    children: /*#__PURE__*/ _jsxs(Row, {
                                        className: "",
                                        children: [
                                            /*#__PURE__*/ _jsxs(Col, {
                                                xs: 12,
                                                md: 6,
                                                lg: 3,
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-18 fw-bold mb-4",
                                                        children: "ร้านค้า"
                                                    }),
                                                    isDisabled ? /*#__PURE__*/ _jsx(Form.Group, {
                                                        className: "mb-2 form-st-3",
                                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: "text",
                                                            name: "rs_reserve_shopname",
                                                            placeholder: "ชื่อร้านค้า : สาขา",
                                                            value: nameShopShow,
                                                            onChange: function(e) {},
                                                            isValid: touched.rs_reserve_shopname && !errors.rs_reserve_shopname,
                                                            isInvalid: !!errors.rs_reserve_shopname,
                                                            disabled: isDisabled,
                                                            readOnly: isDisabled
                                                        })
                                                    }) : /*#__PURE__*/ _jsx(Autocomplete, {
                                                        disablePortal: true,
                                                        options: optionsShop,
                                                        renderInput: function(params) {
                                                            return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({}, params), {
                                                                label: "ชื่อร้านค้า : สาขา",
                                                                className: "select-st-1 mb-2"
                                                            }));
                                                        },
                                                        value: values.rs_reserve_shid && values.rs_reserve_shid > 0 ? optionsShop.filter(function(item2) {
                                                            return item2.value === values.rs_reserve_shid;
                                                        })[0].label : "",
                                                        onChange: function(event, newValue) {
                                                            setFieldValue("rs_reserve_shid", newValue);
                                                        },
                                                        onInputChange: function(event, newInputValue) {
                                                        //setInputValue(newInputValue);
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Col, {
                                                xs: 12,
                                                md: 6,
                                                lg: 3,
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-18 fw-bold mb-4",
                                                        children: "วันที่ทำรายการ"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Form.Group, {
                                                        className: "mb-2 form-st-3",
                                                        children: /*#__PURE__*/ _jsx(DatePicker, {
                                                            inputFormat: "DD/MM/YYYY",
                                                            selected: values.rs_reserve_credate ? moment(values.rs_reserve_credate).toDate() : "",
                                                            onChange: function(date) {
                                                                if (moment(date).isValid()) {
                                                                    setFieldValue("rs_reserve_credate", moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                } else {
                                                                    setFieldValue("rs_reserve_credate", "");
                                                                }
                                                            },
                                                            placeholder: "DD/MM/YYYY",
                                                            className: "w-100 datepicker2",
                                                            value: values.rs_reserve_credate ? moment(values.rs_reserve_credate).format("DD/MM/YYYY") : "",
                                                            disabled: isDisabled,
                                                            readOnly: isDisabled
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Col, {
                                                xs: 12,
                                                md: 6,
                                                lg: 3,
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-18 fw-bold mb-4",
                                                        children: "เซลล์ที่ดูแล"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Form.Group, {
                                                        className: "mb-2 form-st-3",
                                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: "text",
                                                            name: "reserve_salename",
                                                            placeholder: "กรุณากรอกชื่อเซลล์",
                                                            value: values.reserve_salename,
                                                            onChange: function(e) {
                                                                setFieldValue("reserve_salename", e.target.value);
                                                            },
                                                            isValid: touched.reserve_salename && !errors.reserve_salename,
                                                            isInvalid: !!errors.reserve_salename,
                                                            disabled: isDisabled,
                                                            readOnly: isDisabled
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Col, {
                                                xs: 12,
                                                md: 6,
                                                lg: 3,
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-18 fw-bold mb-4",
                                                        children: "สถานะ"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Form.Group, {
                                                        className: "mb-2 form-st-3",
                                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: "text",
                                                            name: "rs_reserve_status_text",
                                                            placeholder: "",
                                                            value: values.rs_reserve_status_text,
                                                            onChange: function(e) {
                                                                setFieldValue("rs_reserve_status_text", e.target.value);
                                                            },
                                                            isValid: touched.rs_reserve_status_text && !errors.rs_reserve_status_text,
                                                            isInvalid: !!errors.rs_reserve_status_text,
                                                            disabled: isDisabled,
                                                            readOnly: isDisabled
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Col, {
                                                xs: 12,
                                                md: 12,
                                                lg: 6,
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-18 fw-bold my-3",
                                                        children: "ติดต่อ 1"
                                                    }),
                                                    /*#__PURE__*/ _jsxs(Row, {
                                                        className: "align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Col, {
                                                                xs: 12,
                                                                md: 12,
                                                                lg: 6,
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "fs-16 fw-bold mb-4",
                                                                        children: "ชื่อ-นามสกุล"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Group, {
                                                                        className: "mb-2 form-st-3",
                                                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "rs_reserve_contactname",
                                                                            placeholder: "ชื่อ-นามสกุล จะขึ้นเมื่อ เลือกร้าน สาขา ร้านค้าแล้ว",
                                                                            value: values.rs_reserve_contactname,
                                                                            onChange: function(e) {
                                                                                setFieldValue("rs_reserve_contactname", e.target.value);
                                                                            },
                                                                            isValid: touched.rs_reserve_contactname && !errors.rs_reserve_contactname,
                                                                            isInvalid: !!errors.rs_reserve_contactname,
                                                                            disabled: isDisabled,
                                                                            readOnly: isDisabled
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs(Col, {
                                                                xs: 12,
                                                                md: 12,
                                                                lg: 6,
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "fs-16 fw-bold mb-4",
                                                                        children: "เบอร์โทร"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Group, {
                                                                        className: "mb-2 form-st-3",
                                                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "rs_reserve_contactphone",
                                                                            placeholder: "เบอร์โทร จะขึ้นเมื่อ เลือกร้าน สาขา ร้านค้าแล้ว",
                                                                            value: values.rs_reserve_contactphone,
                                                                            onChange: function(e) {
                                                                                setFieldValue("rs_reserve_contactphone", e.target.value);
                                                                            },
                                                                            isValid: touched.rs_reserve_contactphone && !errors.rs_reserve_contactphone,
                                                                            isInvalid: !!errors.rs_reserve_contactphone,
                                                                            disabled: isDisabled,
                                                                            readOnly: isDisabled
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-18 fw-bold my-3",
                                                        children: "ติดต่อ 2"
                                                    }),
                                                    /*#__PURE__*/ _jsxs(Row, {
                                                        className: "align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Col, {
                                                                xs: 12,
                                                                md: 12,
                                                                lg: 6,
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "fs-16 fw-bold mb-4",
                                                                        children: "ชื่อ-นามสกุล"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Group, {
                                                                        className: "mb-2 form-st-3",
                                                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "rs_reserve_suptactname",
                                                                            placeholder: "ชื่อ-นามสกุล จะขึ้นเมื่อ เลือกร้าน สาขา ร้านค้าแล้ว",
                                                                            value: values.rs_reserve_suptactname,
                                                                            onChange: function(e) {
                                                                                setFieldValue("rs_reserve_suptactname", e.target.value);
                                                                            },
                                                                            isValid: touched.rs_reserve_suptactname && !errors.rs_reserve_suptactname,
                                                                            isInvalid: !!errors.rs_reserve_suptactname,
                                                                            disabled: isDisabled,
                                                                            readOnly: isDisabled
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs(Col, {
                                                                xs: 12,
                                                                md: 12,
                                                                lg: 6,
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "fs-16 fw-bold mb-4",
                                                                        children: "เบอร์โทร"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Group, {
                                                                        className: "mb-2 form-st-3",
                                                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "rs_reserve_suptactphone",
                                                                            placeholder: "เบอร์โทร จะขึ้นเมื่อ เลือกร้าน สาขา ร้านค้าแล้ว",
                                                                            value: values.rs_reserve_suptactphone,
                                                                            onChange: function(e) {
                                                                                setFieldValue("rs_reserve_suptactphone", e.target.value);
                                                                            },
                                                                            isValid: touched.rs_reserve_suptactphone && !errors.rs_reserve_suptactphone,
                                                                            isInvalid: !!errors.rs_reserve_suptactphone,
                                                                            disabled: isDisabled,
                                                                            readOnly: isDisabled
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Col, {
                                                xs: 12,
                                                md: 12,
                                                lg: 6,
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-18 fw-bold my-3",
                                                        children: "หมายเหตุ"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Form.Group, {
                                                        className: "mb-2 form-st-3",
                                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                                            as: "textarea",
                                                            rows: 5,
                                                            name: "rs_reserve_remark",
                                                            placeholder: "กรุณากรอกหมายเหตุ",
                                                            value: values.rs_reserve_remark,
                                                            onChange: function(e) {
                                                                setFieldValue("rs_reserve_remark", e.target.value);
                                                                setDataInfo(function(prev) {
                                                                    return _object_spread_props(_object_spread({}, prev), {
                                                                        rs_reserve_remark: e.target.value
                                                                    });
                                                                });
                                                            },
                                                            isValid: touched.rs_reserve_remark && !errors.rs_reserve_remark,
                                                            isInvalid: !!errors.rs_reserve_remark,
                                                            disabled: !canEditRemark,
                                                            readOnly: !canEditRemark
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-18 fw-bold my-3",
                                                        children: "โน้ตภายใน"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Form.Group, {
                                                        className: "mb-2 form-st-3",
                                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                                            as: "textarea",
                                                            rows: 5,
                                                            name: "rs_reserve_note",
                                                            placeholder: "กรุณากรอกโน้ตภายใน",
                                                            value: (_values_rs_reserve_note = values.rs_reserve_note) !== null && _values_rs_reserve_note !== void 0 ? _values_rs_reserve_note : "",
                                                            onChange: function(e) {
                                                                setFieldValue("rs_reserve_note", e.target.value);
                                                                setDataInfo(function(prev) {
                                                                    return _object_spread_props(_object_spread({}, prev), {
                                                                        rs_reserve_note: e.target.value
                                                                    });
                                                                });
                                                            },
                                                            isValid: touched.rs_reserve_note && !errors.rs_reserve_note,
                                                            isInvalid: !!errors.rs_reserve_note,
                                                            disabled: !canEditRemark,
                                                            readOnly: !canEditRemark
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-18 fw-bold my-3",
                                                        children: "เครดิต"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Form.Group, {
                                                        className: "mb-2 form-st-3",
                                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: "text",
                                                            name: "rs_reserve_credit",
                                                            placeholder: "กรุณากรอกเครดิต",
                                                            value: (_values_rs_reserve_credit = values.rs_reserve_credit) !== null && _values_rs_reserve_credit !== void 0 ? _values_rs_reserve_credit : "",
                                                            onChange: function(e) {
                                                                setFieldValue("rs_reserve_credit", e.target.value);
                                                                setDataInfo(function(prev) {
                                                                    return _object_spread_props(_object_spread({}, prev), {
                                                                        rs_reserve_credit: e.target.value
                                                                    });
                                                                });
                                                            },
                                                            isValid: touched.rs_reserve_credit && !errors.rs_reserve_credit,
                                                            isInvalid: !!errors.rs_reserve_credit,
                                                            disabled: !canEditRemark,
                                                            readOnly: !canEditRemark
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        mods === "views" && dataInfo.rs_reserve_id ? /*#__PURE__*/ _jsx(ProductCheckActivityTable, {
                            reservationId: dataInfo.rs_reserve_id
                        }) : null,
                        /*#__PURE__*/ _jsx(Card, {
                            className: "card-st-1 mb-4",
                            children: /*#__PURE__*/ _jsx(CardBody, {
                                children: mods && mods === "views" ? /*#__PURE__*/ _jsx(Row, {
                                    className: "align-items-center justify-content-end",
                                    children: /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: "auto",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "d-flex gap-2 ".concat(isMobile ? "flex-column" : ""),
                                            children: /*#__PURE__*/ _jsx(Button, {
                                                variant: "outline-danger",
                                                href: reservationListPath,
                                                className: isMobile ? "w-100" : "",
                                                children: "ย้อนกลับ"
                                            })
                                        })
                                    })
                                }) : /*#__PURE__*/ _jsx(Row, {
                                    className: "align-items-center justify-content-end",
                                    children: /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: "auto",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "d-flex gap-2 ".concat(isMobile ? "flex-column" : ""),
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    variant: "outline-danger",
                                                    href: reservationListPath,
                                                    className: isMobile ? "w-100" : "",
                                                    children: "ยกเลิก"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    onClick: function() {
                                                        if (validateScheduleDatesBeforeSave()) {
                                                            props.saveDataOpen();
                                                        }
                                                    },
                                                    variant: "danger",
                                                    className: isMobile ? "w-100" : "",
                                                    children: "บันทึก"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    ]
                });
            }
        })
    });
}
var PRODUCT_CHECK_ACTION_TEXT = {
    PRODUCT_SCAN_INCREMENT: "สแกนเพิ่มสินค้า",
    PRODUCT_MANUAL_INCREMENT: "เพิ่มสินค้าด้วยปุ่ม",
    PRODUCT_MANUAL_DECREMENT: "ลดสินค้าด้วยปุ่ม",
    PRODUCT_CHECK_COMPLETED: "ตรวจนับสินค้าเสร็จ",
    VIDEO_START: "เริ่มบันทึกวิดีโอ",
    VIDEO_STOP: "หยุดบันทึกวิดีโอ",
    VIDEO_CANCEL: "ยกเลิกการบันทึกวิดีโอ",
    VIDEO_ERROR: "เกิดข้อผิดพลาดในการบันทึกวิดีโอ"
};
var PRODUCT_CHECK_ACTION_COLOR = {
    PRODUCT_SCAN_INCREMENT: "primary",
    PRODUCT_MANUAL_INCREMENT: "success",
    PRODUCT_MANUAL_DECREMENT: "danger",
    PRODUCT_CHECK_COMPLETED: "success",
    VIDEO_START: "info",
    VIDEO_STOP: "secondary",
    VIDEO_CANCEL: "warning",
    VIDEO_ERROR: "danger"
};
function ProductCheckActivityTable(param) {
    var reservationId = param.reservationId;
    var _useState = _sliced_to_array(useState([]), 2), logs = _useState[0], setLogs = _useState[1];
    var _useState1 = _sliced_to_array(useState(1), 2), page = _useState1[0], setPage = _useState1[1];
    var _useState2 = _sliced_to_array(useState(10), 2), pageSize = _useState2[0], setPageSize = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), total = _useState3[0], setTotal = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), loading = _useState4[0], setLoading = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), error = _useState5[0], setError = _useState5[1];
    useEffect(function() {
        var active = true;
        var loadLogs = function() {
            var _ref = _async_to_generator(function() {
                var result, loadError, _loadError_response_data, _loadError_response;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setLoading(true);
                            setError("");
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                productCheckApi.logs(reservationId, page, pageSize)
                            ];
                        case 2:
                            result = _state.sent();
                            if (!active) return [
                                2
                            ];
                            setLogs((result === null || result === void 0 ? void 0 : result.items) || []);
                            setTotal(Number((result === null || result === void 0 ? void 0 : result.total) || 0));
                            return [
                                3,
                                5
                            ];
                        case 3:
                            loadError = _state.sent();
                            if (!active) return [
                                2
                            ];
                            setError((loadError === null || loadError === void 0 ? void 0 : (_loadError_response = loadError.response) === null || _loadError_response === void 0 ? void 0 : (_loadError_response_data = _loadError_response.data) === null || _loadError_response_data === void 0 ? void 0 : _loadError_response_data.message) || "ไม่สามารถโหลดกิจกรรมตรวจสอบสินค้าได้");
                            return [
                                3,
                                5
                            ];
                        case 4:
                            if (active) setLoading(false);
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function loadLogs() {
                return _ref.apply(this, arguments);
            };
        }();
        loadLogs();
        return function() {
            active = false;
        };
    }, [
        page,
        pageSize,
        reservationId
    ]);
    var totalPages = Math.max(1, Math.ceil(total / pageSize));
    var quantityText = function(value) {
        var showSign = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (value === null || value === undefined) return "-";
        var number = Number(value);
        return showSign && number > 0 ? "+".concat(number) : String(number);
    };
    return /*#__PURE__*/ _jsx(Card, {
        className: "card-st-1 mb-1",
        children: /*#__PURE__*/ _jsxs(CardBody, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "fs-18 fw-bold",
                            children: "กิจกรรมตรวจสอบสินค้า"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "text-secondary",
                            children: [
                                "ทั้งหมด ",
                                total,
                                " รายการ"
                            ]
                        })
                    ]
                }),
                error ? /*#__PURE__*/ _jsx(Alert, {
                    variant: "danger",
                    children: error
                }) : null,
                /*#__PURE__*/ _jsx("div", {
                    className: "table-responsive",
                    children: /*#__PURE__*/ _jsxs(Table, {
                        hover: true,
                        bordered: true,
                        className: "align-middle mb-0",
                        children: [
                            /*#__PURE__*/ _jsx("thead", {
                                className: "table-light",
                                children: /*#__PURE__*/ _jsxs("tr", {
                                    children: [
                                        /*#__PURE__*/ _jsx("th", {
                                            className: "text-center",
                                            children: "วันเวลา"
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            children: "ผู้ดำเนินการ"
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            children: "กิจกรรม"
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            children: "สินค้า"
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            className: "text-center",
                                            children: "บาร์โค้ด"
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            className: "text-center",
                                            children: "ก่อน"
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            className: "text-center",
                                            children: "เปลี่ยน"
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            className: "text-center",
                                            children: "หลัง"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("tbody", {
                                children: loading ? /*#__PURE__*/ _jsx("tr", {
                                    children: /*#__PURE__*/ _jsxs("td", {
                                        colSpan: 8,
                                        className: "text-center py-4",
                                        children: [
                                            /*#__PURE__*/ _jsx(Spinner, {
                                                animation: "border",
                                                size: "sm",
                                                className: "me-2"
                                            }),
                                            "กำลังโหลดข้อมูล"
                                        ]
                                    })
                                }) : logs.length === 0 ? /*#__PURE__*/ _jsx("tr", {
                                    children: /*#__PURE__*/ _jsx("td", {
                                        colSpan: 8,
                                        className: "text-center text-secondary py-4",
                                        children: "ยังไม่มีกิจกรรมตรวจสอบสินค้า"
                                    })
                                }) : logs.map(function(log) {
                                    return /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "text-center text-nowrap",
                                                children: moment.utc(log.product_check_log_createdat).format("DD/MM/YYYY HH:mm:ss")
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: log.adminName || "-"
                                            }),
                                            /*#__PURE__*/ _jsxs("td", {
                                                children: [
                                                    /*#__PURE__*/ _jsx(Badge, {
                                                        bg: PRODUCT_CHECK_ACTION_COLOR[log.product_check_log_action] || "secondary",
                                                        text: [
                                                            "info",
                                                            "warning"
                                                        ].includes(PRODUCT_CHECK_ACTION_COLOR[log.product_check_log_action]) ? "dark" : undefined,
                                                        className: "px-2 py-2",
                                                        children: PRODUCT_CHECK_ACTION_TEXT[log.product_check_log_action] || log.product_check_log_action
                                                    }),
                                                    log.product_check_log_message ? /*#__PURE__*/ _jsx("div", {
                                                        className: "small text-danger",
                                                        children: log.product_check_log_message
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("td", {
                                                children: [
                                                    log.productName || "-",
                                                    log.isFree ? /*#__PURE__*/ _jsx(Badge, {
                                                        bg: "warning",
                                                        text: "dark",
                                                        className: "ms-2",
                                                        children: "ของแถม"
                                                    }) : null,
                                                    log.isTester ? /*#__PURE__*/ _jsx(Badge, {
                                                        bg: "info",
                                                        text: "dark",
                                                        className: "ms-2",
                                                        children: "สินค้าทดลอง"
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "text-center",
                                                children: log.product_check_log_barcode || "-"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "text-center",
                                                children: quantityText(log.product_check_log_qtybefore)
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "text-center",
                                                children: quantityText(log.product_check_log_qtychange, true)
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "text-center",
                                                children: quantityText(log.product_check_log_qtyafter)
                                            })
                                        ]
                                    }, log.product_check_log_id);
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex flex-wrap justify-content-end align-items-center gap-2 mt-3",
                    children: [
                        /*#__PURE__*/ _jsx(Form.Select, {
                            value: pageSize,
                            style: {
                                width: "auto"
                            },
                            onChange: function(event) {
                                setPageSize(Number(event.target.value));
                                setPage(1);
                            },
                            children: [
                                10,
                                20,
                                50
                            ].map(function(size) {
                                return /*#__PURE__*/ _jsxs("option", {
                                    value: size,
                                    children: [
                                        size,
                                        " รายการ"
                                    ]
                                }, size);
                            })
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            className: "text-secondary",
                            children: [
                                "หน้า ",
                                page,
                                " / ",
                                totalPages
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            variant: "outline-secondary",
                            disabled: loading || page <= 1,
                            onClick: function() {
                                return setPage(function(current) {
                                    return current - 1;
                                });
                            },
                            children: "ก่อนหน้า"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            variant: "outline-secondary",
                            disabled: loading || page >= totalPages,
                            onClick: function() {
                                return setPage(function(current) {
                                    return current + 1;
                                });
                            },
                            children: "ถัดไป"
                        })
                    ]
                })
            ]
        })
    });
}
var CATALOG_MODAL_PAGE_SIZE = 20;
function ProductModal(_param) {
    var productData = _param.productData, setProductData = _param.setProductData, bookId = _param.bookId, props = _object_without_properties(_param, [
        "productData",
        "setProductData",
        "bookId"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var reportId = useParams().reportId;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("md"));
    var reloadCalMain = props.reloadCalMain ? props.reloadCalMain : false;
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), appliedFilterText = _useState1[0], setAppliedFilterText = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), tabledata = _useState2[0], setTabledata = _useState2[1];
    var catalogModalBodyRef = useRef(null);
    var catalogListScrollRef = useRef(null);
    var catalogAppendRef = useRef(false);
    var catalogLoadMoreLockRef = useRef(false);
    var catalogProcessedDataRef = useRef(null);
    var _useState3 = _sliced_to_array(useState(1), 2), catalogPageId = _useState3[0], setCatalogPageId = _useState3[1];
    var _useState4 = _sliced_to_array(useState(1), 2), catalogTotalPage = _useState4[0], setCatalogTotalPage = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), catalogTotal = _useState5[0], setCatalogTotal = _useState5[1];
    var _useState6 = _sliced_to_array(useState(false), 2), isCatalogLoadingMore = _useState6[0], setIsCatalogLoadingMore = _useState6[1];
    var _useState7 = _sliced_to_array(useState("all"), 2), tabTypePd = _useState7[0], setTabTypePd = _useState7[1];
    var _useState8 = _sliced_to_array(useState(1), 2), tabCatalogPd = _useState8[0], setTabCatalogPd = _useState8[1];
    var _useState9 = _sliced_to_array(useState(0), 2), tabBrandType = _useState9[0], setTabBrandType = _useState9[1];
    var _useState10 = _sliced_to_array(useState(0), 2), tabPdType = _useState10[0], setTabPdType = _useState10[1];
    var _useState11 = _sliced_to_array(useState(0), 2), tabCateType = _useState11[0], setTabCateType = _useState11[1];
    var _useState12 = _sliced_to_array(useState(0), 2), tabSubCateType = _useState12[0], setTabSubCateType = _useState12[1];
    var _useState13 = _sliced_to_array(useState(0), 2), bookIdChk = _useState13[0], setBookIdChk = _useState13[1];
    var _useState14 = _sliced_to_array(useState(null), 2), statusNew = _useState14[0], setStatusNew = _useState14[1];
    var _useState15 = _sliced_to_array(useState(null), 2), statusRecom = _useState15[0], setStatusRecom = _useState15[1];
    var _useState16 = _sliced_to_array(useState(null), 2), promotion = _useState16[0], setPromotion = _useState16[1];
    var _useState17 = _sliced_to_array(useState(null), 2), productTypeId = _useState17[0], setProductTypeId = _useState17[1];
    var _useState18 = _sliced_to_array(useState([]), 2), dataPdCatalog = _useState18[0], setDataPdCatalog = _useState18[1];
    var _useState19 = _sliced_to_array(useState([]), 2), dataPdType = _useState19[0], setDataPdType = _useState19[1];
    var _useState20 = _sliced_to_array(useState([]), 2), brandType = _useState20[0], setBrandType = _useState20[1];
    var _useState21 = _sliced_to_array(useState([]), 2), productType = _useState21[0], setProductType = _useState21[1];
    var _useState22 = _sliced_to_array(useState([]), 2), typeCategory = _useState22[0], setTypeCategory = _useState22[1];
    var _useState23 = _sliced_to_array(useState([]), 2), typeSubCategory = _useState23[0], setTypeSubCategory = _useState23[1];
    var _useState24 = _sliced_to_array(useState([]), 2), summary = _useState24[0], setSummary = _useState24[1];
    var handleClose = function() {
        return props.onHide();
    };
    var getAllMstTypeProductReducer = useAppSelector(function(state) {
        return state.getAllMstTypeProductReducer;
    });
    var getDataAllCatalogReducer = useAppSelector(function(state) {
        return state.getDataAllCatalogReducer;
    });
    var getMstBrandCateReducer = useAppSelector(function(state) {
        return state.getMstBrandCateReducer;
    });
    var getProductTypeReducer = useAppSelector(function(state) {
        return state.getProductTypeReducer;
    });
    var getCategoryReducer = useAppSelector(function(state) {
        return state.getCategoryReducer;
    });
    var getSubCategoryReducer = useAppSelector(function(state) {
        return state.getSubCategoryReducer;
    });
    var getCatalogSummaryReducer = useAppSelector(function(state) {
        return state.getCatalogSummaryReducer;
    });
    var createRsreserveReducer = useAppSelector(function(state) {
        return state.createRsreserveReducer;
    });
    var handleClick = function() {
        props.onHide();
    };
    var getDataMst = function() {
        dispatch(getAllMstTypeProduct({
            status: null
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var resetCatalogPaging = function() {
        catalogAppendRef.current = false;
        catalogLoadMoreLockRef.current = false;
        catalogProcessedDataRef.current = null;
        setCatalogPageId(1);
        setCatalogTotalPage(1);
        setCatalogTotal(0);
        setIsCatalogLoadingMore(false);
    };
    var scrollCatalogToTop = function() {
        if (catalogModalBodyRef.current) {
            catalogModalBodyRef.current.scrollTop = 0;
        }
        if (catalogListScrollRef.current) {
            catalogListScrollRef.current.scrollTop = 0;
        }
    };
    var resetCatalogPagingToTop = function() {
        resetCatalogPaging();
        scrollCatalogToTop();
    };
    var getDataTable = function() {
        var pageId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, append = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        catalogAppendRef.current = append;
        dispatch(getDataAllCatalog({
            searchtext: appliedFilterText,
            statusnew: Number(tabCatalogPd) === 3 ? 1 : null,
            statusrecom: Number(tabCatalogPd) === 2 ? 1 : null,
            promotion: Number(tabCatalogPd) === 4 ? 1 : null,
            brandid: Number(tabCatalogPd) === 6 && Number(tabBrandType) > 0 ? parseInt(tabBrandType, 10) : null,
            producttypeid: Number(tabCatalogPd) === 5 && Number(tabPdType) > 0 ? parseInt(tabPdType, 10) : null,
            categoryid: Number(tabCatalogPd) === 5 && Number(tabCateType) > 0 ? parseInt(tabCateType, 10) : null,
            categorysubid: Number(tabCatalogPd) === 5 && Number(tabSubCateType) > 0 ? parseInt(tabSubCateType, 10) : null,
            bookid: bookId,
            shopid: props.shopId,
            branchid: props.branchId,
            catalogid: [],
            pageId: pageId,
            pageSize: CATALOG_MODAL_PAGE_SIZE
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        setIsLoading(getAllMstTypeProductReducer.isFetching || getDataAllCatalogReducer.isFetching && !catalogLoadMoreLockRef.current || createRsreserveReducer.isFetching || getMstBrandCateReducer.isFetching || getProductTypeReducer.isFetching || getCategoryReducer.isFetching || getSubCategoryReducer.isFetching || getCatalogSummaryReducer.isFetching);
        if (getAllMstTypeProductReducer.data && !getAllMstTypeProductReducer.isError) {
            var rawData = getAllMstTypeProductReducer.data.data;
            var withNo = rawData.map(function(item, index) {
                return _object_spread_props(_object_spread({}, item), {
                    set_producttype_no: index + 1
                });
            });
            setDataPdType(withNo);
        }
        if (getDataAllCatalogReducer.data && !getDataAllCatalogReducer.isError && catalogProcessedDataRef.current !== getDataAllCatalogReducer.data) {
            var payload = getDataAllCatalogReducer.data;
            catalogProcessedDataRef.current = payload;
            var responseData = payload === null || payload === void 0 ? void 0 : payload.data;
            var rawData2 = Array.isArray(responseData) ? responseData : Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.data) ? responseData.data : Array.isArray(payload) ? payload : [];
            var pagination = (responseData === null || responseData === void 0 ? void 0 : responseData.pagination) || (payload === null || payload === void 0 ? void 0 : payload.pagination) || {};
            var responsePage = pagination.pageId || 1;
            var responsePageSize = pagination.pageSize || CATALOG_MODAL_PAGE_SIZE;
            var withNo2 = rawData2.map(function(item, index) {
                return _object_spread_props(_object_spread({}, item), {
                    cl_catalog_no: (responsePage - 1) * responsePageSize + index + 1,
                    ClDetail: (item.ClDetail || []).map(function(detail, idx) {
                        return _object_spread_props(_object_spread({}, detail), {
                            cl_detail_no: idx + 1,
                            cl_detail_amount: detail.cl_detail_amount || 0
                        });
                    })
                });
            });
            var shouldAppendCatalog = catalogAppendRef.current || responsePage > 1;
            setTabledata(function(prev) {
                return shouldAppendCatalog ? _to_consumable_array(prev).concat(_to_consumable_array(withNo2)) : withNo2;
            });
            setCatalogPageId(responsePage);
            setCatalogTotalPage(pagination.totalPage || (rawData2.length >= responsePageSize ? responsePage + 1 : responsePage));
            setCatalogTotal(pagination.total || (shouldAppendCatalog ? (responsePage - 1) * responsePageSize + withNo2.length : withNo2.length));
            setIsCatalogLoadingMore(false);
            catalogLoadMoreLockRef.current = false;
            catalogAppendRef.current = false;
        }
        if (getDataAllCatalogReducer.isError) {
            setIsCatalogLoadingMore(false);
            catalogLoadMoreLockRef.current = false;
            catalogAppendRef.current = false;
        }
        if (getMstBrandCateReducer.data && !getMstBrandCateReducer.isError) {
            setBrandType(getMstBrandCateReducer.data.data || []);
        }
        if (getProductTypeReducer.data && !getProductTypeReducer.isError) {
            setProductType(getProductTypeReducer.data.data || []);
            setDataPdType(getProductTypeReducer.data.data || []);
        }
        if (getCategoryReducer.data && !getCategoryReducer.isError) {
            setTypeCategory(getCategoryReducer.data.data || []);
        }
        if (getSubCategoryReducer.data && !getSubCategoryReducer.isError) {
            setTypeSubCategory(getSubCategoryReducer.data.data || []);
        }
        if (getCatalogSummaryReducer.data && !getCatalogSummaryReducer.isError) {
            setSummary(getCatalogSummaryReducer.data.data || []);
        }
        if (createRsreserveReducer.data && !createRsreserveReducer.isError) {
            var createdData = createRsreserveReducer.data.data;
            dispatch(clearCreateRsreserve());
            props.reDataItem();
            if (createdData.rs_catalog_clid && createdData.rs_catalog_clid > 0) {
                setProductData(function(prev) {
                    return _to_consumable_array(prev).concat([
                        createdData.rs_catalog_clid
                    ]);
                });
            }
        }
    }, [
        getAllMstTypeProductReducer,
        getDataAllCatalogReducer,
        createRsreserveReducer,
        getMstBrandCateReducer,
        getProductTypeReducer,
        getCategoryReducer,
        getSubCategoryReducer,
        getCatalogSummaryReducer
    ]);
    useEffect(function() {
        getDataMst();
    }, []);
    useEffect(function() {
        if (bookId && Number(bookId) > 0) {
            dispatch(getCatalogSummary({
                bookid: parseInt(bookId, 10),
                branchid: Number(props.branchId) || undefined
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else {
            setSummary([]);
        }
    }, [
        bookId,
        props.branchId
    ]);
    useEffect(function() {
        if (Number(tabCatalogPd) === 6 && brandType.length === 0 && bookId) {
            dispatch(getMstBrandCate(parseInt(bookId, 10), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
        if (Number(tabCatalogPd) === 5 && productType.length === 0) {
            dispatch(getProductType());
        }
    }, [
        tabCatalogPd,
        bookId
    ]);
    useEffect(function() {
        if (Number(tabCatalogPd) === 5 && Number(tabPdType) > 0) {
            dispatch(getCategory(parseInt(tabPdType, 10)));
        } else {
            setTypeCategory([]);
            setTypeSubCategory([]);
        }
    }, [
        tabCatalogPd,
        tabPdType
    ]);
    useEffect(function() {
        if (Number(tabCatalogPd) === 5 && Number(tabPdType) > 0 && Number(tabCateType) > 0) {
            dispatch(getSubCategory(parseInt(tabPdType, 10), parseInt(tabCateType, 10)));
        } else {
            setTypeSubCategory([]);
        }
    }, [
        tabCatalogPd,
        tabPdType,
        tabCateType
    ]);
    useEffect(function() {
        if (bookId && bookId > 0 && bookId !== bookIdChk) {
            setBookIdChk(bookId);
            getDataTable(1, false);
        } else if ((!bookId || bookId === null || bookId === undefined || bookId === 0) && bookId !== bookIdChk) {
            setBookIdChk(bookId);
            setTabledata([]);
        }
    }, [
        bookId,
        bookIdChk,
        appliedFilterText,
        statusNew,
        statusRecom,
        promotion,
        productTypeId,
        tabCatalogPd,
        tabBrandType,
        tabPdType,
        tabCateType,
        tabSubCateType
    ]);
    useEffect(function() {
        if (reloadCalMain) {
            getDataTable(1, false);
            props.setReloadCalMain(false);
        }
    }, [
        reloadCalMain
    ]);
    // เปลี่ยนจำนวนสินค้า
    var handleQtyChangeCatalog = function(pid, idx, value) {
        var normalizedValue = normalizeQuantityInput(value);
        setTabledata(function(prev) {
            return prev.map(function(p) {
                return p.cl_catalog_id === pid ? _object_spread_props(_object_spread({}, p), {
                    ClDetail: p.ClDetail.map(function(b) {
                        return b.cl_detail_id === idx ? _object_spread_props(_object_spread({}, b), {
                            cl_detail_amount: normalizedValue
                        }) : b;
                    })
                }) : p;
            });
        });
    };
    var handleAddToCart = function(catalogId) {
        // Logic to add the item to the cart
        //console.log("Adding to cart:", catalogId);
        if (catalogId && catalogId > 0) {
            // Add the selected product to the cart
            var selectedProduct = tabledata.find(function(item) {
                return item.cl_catalog_id === catalogId;
            });
            //console.log("Selected product:", selectedProduct);
            if (reportId && selectedProduct && reportId > 0) {
                var payload = {
                    rs_catalog_rsid: parseInt(reportId, 10),
                    rs_catalog_clid: selectedProduct.cl_catalog_id && selectedProduct.cl_catalog_id > 0 ? parseInt(selectedProduct.cl_catalog_id, 10) : null,
                    rs_catalog_bookid: selectedProduct.cl_catalog_bookid && selectedProduct.cl_catalog_bookid > 0 ? parseInt(selectedProduct.cl_catalog_bookid, 10) : null,
                    rs_catalog_productid: selectedProduct.cl_catalog_productid && selectedProduct.cl_catalog_productid > 0 ? parseInt(selectedProduct.cl_catalog_productid, 10) : null,
                    rs_catalog_promotionid: selectedProduct.cl_catalog_promotionid && selectedProduct.cl_catalog_promotionid > 0 ? parseInt(selectedProduct.cl_catalog_promotionid, 10) : null,
                    rs_catalog_image: selectedProduct.cl_catalog_image && selectedProduct.cl_catalog_image != null && selectedProduct.cl_catalog_image !== "" ? selectedProduct.cl_catalog_image.trim() : null,
                    rs_catalog_name: selectedProduct.cl_catalog_name && selectedProduct.cl_catalog_name != null && selectedProduct.cl_catalog_name !== "" ? selectedProduct.cl_catalog_name.trim() : null,
                    rs_catalog_namela: selectedProduct.cl_catalog_namela && selectedProduct.cl_catalog_namela != null && selectedProduct.cl_catalog_namela !== "" ? selectedProduct.cl_catalog_namela.trim() : null,
                    rs_catalog_nameen: selectedProduct.cl_catalog_nameen && selectedProduct.cl_catalog_nameen != null && selectedProduct.cl_catalog_nameen !== "" ? selectedProduct.cl_catalog_nameen.trim() : null,
                    rsDetail: selectedProduct.ClDetail && selectedProduct.ClDetail.length > 0 ? selectedProduct.ClDetail.map(function(detail) {
                        return {
                            rs_detail_clid: detail.cl_detail_clid && detail.cl_detail_clid > 0 ? parseInt(detail.cl_detail_clid, 10) : null,
                            rs_detail_productid: selectedProduct.cl_catalog_productid && selectedProduct.cl_catalog_productid > 0 ? parseInt(selectedProduct.cl_catalog_productid, 10) : null,
                            rs_detail_cldetailid: detail.cl_detail_id && detail.cl_detail_id > 0 ? parseInt(detail.cl_detail_id, 10) : null,
                            rs_detail_barcode: detail.cl_detail_barcode && detail.cl_detail_barcode !== "" && detail.cl_detail_barcode !== null ? detail.cl_detail_barcode.trim() : null,
                            rs_detail_amount: detail.cl_detail_amount && detail.cl_detail_amount > 0 ? parseInt(detail.cl_detail_amount, 10) : 0,
                            rs_detail_stamount: detail.cl_detail_stamount && detail.cl_detail_stamount > 0 ? parseInt(detail.cl_detail_stamount, 10) : 0,
                            rs_detail_unitid: detail.cl_detail_unitid && detail.cl_detail_unitid > 0 ? parseInt(detail.cl_detail_unitid, 10) : null,
                            rs_detail_ratio: detail.cl_detail_ratio && detail.cl_detail_ratio > 0 ? parseInt(detail.cl_detail_ratio, 10) : 0,
                            rs_detail_ratiooption: detail.cl_detail_ratiooption && detail.cl_detail_ratiooption > 0 ? parseInt(detail.cl_detail_ratiooption, 10) : 0,
                            rs_detail_price: detail.cl_detail_price !== "" && detail.cl_detail_price !== null && detail.cl_detail_price !== undefined ? parseFloat(detail.cl_detail_price) : null,
                            rs_detail_discount: detail.cl_detail_discount !== "" && detail.cl_detail_discount !== null && detail.cl_detail_discount !== undefined ? parseFloat(detail.cl_detail_discount) : null,
                            rs_detail_wholesale: detail.cl_detail_wholesale !== "" && detail.cl_detail_wholesale !== null && detail.cl_detail_wholesale !== undefined ? parseFloat(detail.cl_detail_wholesale) : null,
                            rs_detail_wholesalevat: detail.cl_detail_wholesalevat !== "" && detail.cl_detail_wholesalevat !== null && detail.cl_detail_wholesalevat !== undefined ? parseFloat(detail.cl_detail_wholesalevat) : null,
                            rs_detail_wholesaledis: detail.cl_detail_wholesaledis !== "" && detail.cl_detail_wholesaledis !== null && detail.cl_detail_wholesaledis !== undefined ? parseFloat(detail.cl_detail_wholesaledis) : null,
                            rs_detail_wholesalevatdis: detail.cl_detail_wholesalevatdis !== "" && detail.cl_detail_wholesalevatdis !== null && detail.cl_detail_wholesalevatdis !== undefined ? parseFloat(detail.cl_detail_wholesalevatdis) : null,
                            rs_detail_wholesaleavg: detail.cl_detail_wholesaleavg !== "" && detail.cl_detail_wholesaleavg !== null && detail.cl_detail_wholesaleavg !== undefined ? parseFloat(detail.cl_detail_wholesaleavg) : null
                        };
                    }) : []
                };
                //console.log("Payload for createRsreserve:", payload);
                dispatch(createRsreserve(payload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
        }
    };
    var mainCounts = useMemo(function() {
        if (summary && summary.length > 0) {
            var _firstItem_totalProducts, _firstItem_totalRecommend, _firstItem_totalNew, _firstItem_totalPromotion;
            var firstItem = summary[0];
            var totalBrand = 0;
            var totalProductType = 0;
            var totalCategory = 0;
            var totalCategorySub = 0;
            summary.forEach(function(item) {
                var _item_brand, _item_producttype, _item_category, _item_categorysub;
                (_item_brand = item.brand) === null || _item_brand === void 0 ? void 0 : _item_brand.forEach(function(b) {
                    totalBrand += b.totalProducts || 0;
                });
                (_item_producttype = item.producttype) === null || _item_producttype === void 0 ? void 0 : _item_producttype.forEach(function(p) {
                    totalProductType += p.totalProducts || 0;
                });
                (_item_category = item.category) === null || _item_category === void 0 ? void 0 : _item_category.forEach(function(c) {
                    totalCategory += c.totalProducts || 0;
                });
                (_item_categorysub = item.categorysub) === null || _item_categorysub === void 0 ? void 0 : _item_categorysub.forEach(function(cs) {
                    totalCategorySub += cs.totalProducts || 0;
                });
            });
            return {
                total: ((_firstItem_totalProducts = firstItem.totalProducts) === null || _firstItem_totalProducts === void 0 ? void 0 : _firstItem_totalProducts.cl_catalog_id) || 0,
                recommend: ((_firstItem_totalRecommend = firstItem.totalRecommend) === null || _firstItem_totalRecommend === void 0 ? void 0 : _firstItem_totalRecommend.cl_catalog_id) || 0,
                new: ((_firstItem_totalNew = firstItem.totalNew) === null || _firstItem_totalNew === void 0 ? void 0 : _firstItem_totalNew.cl_catalog_id) || 0,
                promotion: ((_firstItem_totalPromotion = firstItem.totalPromotion) === null || _firstItem_totalPromotion === void 0 ? void 0 : _firstItem_totalPromotion.cl_catalog_id) || 0,
                brand: totalBrand,
                productType: totalProductType,
                category: totalCategory,
                categorySub: totalCategorySub
            };
        }
        return {
            total: 0,
            recommend: 0,
            new: 0,
            promotion: 0,
            brand: 0,
            productType: 0,
            category: 0,
            categorySub: 0
        };
    }, [
        summary
    ]);
    var summaryMaps = useMemo(function() {
        var brand = {};
        var productTypeMap = {};
        var category = {};
        var categorySub = {};
        summary === null || summary === void 0 ? void 0 : summary.forEach(function(item) {
            var _item_brand, _item_producttype, _item_category, _item_categorysub;
            (_item_brand = item.brand) === null || _item_brand === void 0 ? void 0 : _item_brand.forEach(function(b) {
                brand[b.id] = b.totalProducts || 0;
            });
            (_item_producttype = item.producttype) === null || _item_producttype === void 0 ? void 0 : _item_producttype.forEach(function(p) {
                productTypeMap[p.id] = p.totalProducts || 0;
            });
            (_item_category = item.category) === null || _item_category === void 0 ? void 0 : _item_category.forEach(function(c) {
                category[c.id] = c.totalProducts || 0;
            });
            (_item_categorysub = item.categorysub) === null || _item_categorysub === void 0 ? void 0 : _item_categorysub.forEach(function(cs) {
                categorySub[cs.id] = cs.totalProducts || 0;
            });
        });
        return {
            brand: brand,
            productType: productTypeMap,
            category: category,
            categorySub: categorySub
        };
    }, [
        summary
    ]);
    useEffect(function() {
        if (Number(tabCatalogPd) === 6 && Number(tabBrandType) > 0 && getCatalogSummaryReducer.data && Number(summaryMaps.brand[tabBrandType] || 0) === 0) {
            setTabBrandType(0);
            resetCatalogPagingToTop();
            setBookIdChk(0);
        }
    }, [
        getCatalogSummaryReducer.data,
        summaryMaps.brand,
        tabBrandType,
        tabCatalogPd
    ]);
    var handleCatalogScroll = function(event) {
        var target = event.currentTarget;
        if (!target || getDataAllCatalogReducer.isFetching || catalogLoadMoreLockRef.current || isCatalogLoadingMore || catalogPageId >= catalogTotalPage) {
            return;
        }
        var distanceFromBottom = target.scrollHeight - target.scrollTop - target.clientHeight;
        if (distanceFromBottom <= 120) {
            var nextPage = catalogPageId + 1;
            catalogLoadMoreLockRef.current = true;
            setIsCatalogLoadingMore(true);
            getDataTable(nextPage, true);
        }
    };
    var getCatalogDisplayNames = function(item) {
        return {
            th: (item === null || item === void 0 ? void 0 : item.cl_catalog_name) || "",
            en: (item === null || item === void 0 ? void 0 : item.cl_catalog_nameen) || "",
            la: (item === null || item === void 0 ? void 0 : item.cl_catalog_namela) || ""
        };
    };
    var CatalogNameDisplay = function(param) {
        var item = param.item, maxWidth = param.maxWidth;
        var names = getCatalogDisplayNames(item);
        var textStyle = {
            maxWidth: maxWidth,
            whiteSpace: "normal",
            overflowWrap: "break-word",
            wordBreak: "break-word",
            textAlign: "left"
        };
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Col, {
                    xs: 12,
                    className: "text-left",
                    style: _object_spread_props(_object_spread({}, textStyle), {
                        fontWeight: "bold"
                    }),
                    children: names.th || "-"
                }),
                /*#__PURE__*/ _jsx(Col, {
                    xs: 12,
                    className: "text-left",
                    style: _object_spread_props(_object_spread({}, textStyle), {
                        color: "#555",
                        fontSize: 14
                    }),
                    children: names.en || "-"
                }),
                /*#__PURE__*/ _jsx(Col, {
                    xs: 12,
                    className: "text-left",
                    style: _object_spread_props(_object_spread({}, textStyle), {
                        color: "#666",
                        fontSize: 14
                    }),
                    children: names.la || "-"
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        fullscreen: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "แคตตาล็อกสินค้า"
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Body, {
                ref: catalogModalBodyRef,
                onScroll: isMobile ? handleCatalogScroll : undefined,
                style: {
                    overflowY: "auto"
                },
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "align-items-center",
                        children: /*#__PURE__*/ _jsxs(Nav, {
                            variant: "pills",
                            activeKey: String(tabCatalogPd),
                            onSelect: function(selectedKey) {
                                var nextTab = Number(selectedKey);
                                setTabCatalogPd(nextTab);
                                setTabTypePd("all");
                                setTabBrandType(0);
                                setTabPdType(0);
                                setTabCateType(0);
                                setTabSubCateType(0);
                                setProductTypeId(0);
                                setStatusNew(nextTab === 3 ? 1 : 0);
                                setStatusRecom(nextTab === 2 ? 1 : 0);
                                setPromotion(nextTab === 4 ? 1 : 0);
                                resetCatalogPagingToTop();
                                setBookIdChk(0);
                            },
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ _jsx(Nav.Item, {
                                    children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                        className: "tc-13 nav-danger",
                                        eventKey: "1",
                                        children: [
                                            "ทั้งหมด (",
                                            mainCounts.total,
                                            ")"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Nav.Item, {
                                    children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                        className: "tc-13 nav-danger",
                                        eventKey: "2",
                                        children: [
                                            "สินค้าขายดี (",
                                            mainCounts.recommend,
                                            ")"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Nav.Item, {
                                    children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                        className: "tc-13 nav-danger",
                                        eventKey: "3",
                                        children: [
                                            "สินค้ามาใหม่ (",
                                            mainCounts.new,
                                            ")"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Nav.Item, {
                                    children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                        className: "tc-13 nav-danger",
                                        eventKey: "4",
                                        children: [
                                            "โปรโมชั่น (",
                                            mainCounts.promotion,
                                            ")"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Nav.Item, {
                                    children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                        className: "tc-13 nav-danger",
                                        eventKey: "5",
                                        children: [
                                            "ประเภทสินค้า (",
                                            mainCounts.productType,
                                            ")"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Nav.Item, {
                                    children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                        className: "tc-13 nav-danger",
                                        eventKey: "6",
                                        children: [
                                            "แบรนด์ (",
                                            mainCounts.brand,
                                            ")"
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    Number(tabCatalogPd) === 6 ? /*#__PURE__*/ _jsxs("div", {
                        className: "align-items-center mt-3",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "fs-18 fw-bold mb-3",
                                children: "แบรนด์"
                            }),
                            /*#__PURE__*/ _jsxs(Nav, {
                                variant: "pills",
                                activeKey: String(tabBrandType),
                                onSelect: function(selectedKey) {
                                    setTabBrandType(Number(selectedKey));
                                    resetCatalogPagingToTop();
                                    setBookIdChk(0);
                                },
                                className: "mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Nav.Item, {
                                        children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                            className: "tc-13 nav-danger",
                                            eventKey: "0",
                                            children: [
                                                "ทั้งหมด (",
                                                mainCounts.brand,
                                                ")"
                                            ]
                                        })
                                    }),
                                    brandType && brandType.length > 0 ? brandType.filter(function(item) {
                                        return Number(summaryMaps.brand[item.set_brand_id] || 0) > 0;
                                    }).map(function(item) {
                                        return /*#__PURE__*/ _jsx(Nav.Item, {
                                            children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                                className: "tc-13 nav-danger",
                                                eventKey: String(item.set_brand_id),
                                                children: [
                                                    item.set_brand_name,
                                                    " (",
                                                    summaryMaps.brand[item.set_brand_id] || 0,
                                                    ")"
                                                ]
                                            })
                                        }, item.set_brand_id);
                                    }) : null
                                ]
                            })
                        ]
                    }) : null,
                    tabCatalogPd && tabCatalogPd == 5 ? /*#__PURE__*/ _jsxs("div", {
                        className: "align-items-center mt-3",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "fs-18 fw-bold mb-3",
                                children: "ประเภทสินค้า"
                            }),
                            /*#__PURE__*/ _jsxs(Nav, {
                                variant: "pills",
                                activeKey: String(tabTypePd),
                                onSelect: function(selectedKey) {
                                    setTabTypePd(selectedKey);
                                    setTabPdType(selectedKey === "all" ? 0 : Number(selectedKey));
                                    setTabCateType(0);
                                    setTabSubCateType(0);
                                    if (selectedKey === "all") {
                                        setProductTypeId(0);
                                    } else {
                                        setProductTypeId(selectedKey);
                                    }
                                    resetCatalogPagingToTop();
                                    setBookIdChk(0);
                                },
                                className: "mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Nav.Item, {
                                        children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                            className: "tc-13 nav-danger",
                                            eventKey: "all",
                                            children: [
                                                "ทั้งหมด (",
                                                mainCounts.productType,
                                                ")"
                                            ]
                                        })
                                    }),
                                    dataPdType && dataPdType.length > 0 ? /*#__PURE__*/ _jsx(_Fragment, {
                                        children: dataPdType.map(function(item) {
                                            return /*#__PURE__*/ _jsx(Nav.Item, {
                                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                                    className: "tc-13 nav-danger ".concat(String(tabTypePd) === String(item.set_producttype_id) ? "active" : ""),
                                                    eventKey: String(item.set_producttype_id),
                                                    children: [
                                                        item.set_producttype_name,
                                                        " (",
                                                        summaryMaps.productType[item.set_producttype_id] || 0,
                                                        ")"
                                                    ]
                                                })
                                            }, item.set_producttype_id);
                                        })
                                    }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                ]
                            }),
                            Number(tabPdType) > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-18 fw-bold mb-3",
                                        children: "หมวดหมู่หลัก"
                                    }),
                                    /*#__PURE__*/ _jsxs(Nav, {
                                        variant: "pills",
                                        activeKey: String(tabCateType),
                                        onSelect: function(selectedKey) {
                                            setTabCateType(Number(selectedKey));
                                            setTabSubCateType(0);
                                            resetCatalogPagingToTop();
                                            setBookIdChk(0);
                                        },
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Nav.Item, {
                                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                                    className: "tc-13 nav-danger",
                                                    eventKey: "0",
                                                    children: [
                                                        "หมวดหมู่หลักทั้งหมด (",
                                                        mainCounts.category,
                                                        ")"
                                                    ]
                                                })
                                            }),
                                            typeCategory && typeCategory.length > 0 ? typeCategory.map(function(item) {
                                                return /*#__PURE__*/ _jsx(Nav.Item, {
                                                    children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                                        className: "tc-13 nav-danger",
                                                        eventKey: String(item.set_productcategory_id),
                                                        children: [
                                                            item.set_productcategory_name,
                                                            " (",
                                                            summaryMaps.category[item.set_productcategory_id] || 0,
                                                            ")"
                                                        ]
                                                    })
                                                }, item.set_productcategory_id);
                                            }) : null
                                        ]
                                    })
                                ]
                            }) : null,
                            Number(tabCateType) > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-18 fw-bold mb-3",
                                        children: "หมวดหมู่ย่อย"
                                    }),
                                    /*#__PURE__*/ _jsxs(Nav, {
                                        variant: "pills",
                                        activeKey: String(tabSubCateType),
                                        onSelect: function(selectedKey) {
                                            setTabSubCateType(Number(selectedKey));
                                            resetCatalogPagingToTop();
                                            setBookIdChk(0);
                                        },
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Nav.Item, {
                                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                                    className: "tc-13 nav-danger",
                                                    eventKey: "0",
                                                    children: [
                                                        "หมวดหมู่ย่อยทั้งหมด (",
                                                        mainCounts.categorySub,
                                                        ")"
                                                    ]
                                                })
                                            }),
                                            typeSubCategory && typeSubCategory.length > 0 ? typeSubCategory.map(function(item) {
                                                return /*#__PURE__*/ _jsx(Nav.Item, {
                                                    children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                                        className: "tc-13 nav-danger",
                                                        eventKey: String(item.set_productcategorysub_id),
                                                        children: [
                                                            item.set_productcategorysub_name,
                                                            " (",
                                                            summaryMaps.categorySub[item.set_productcategorysub_id] || 0,
                                                            ")"
                                                        ]
                                                    })
                                                }, item.set_productcategorysub_id);
                                            }) : null
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    }) : /*#__PURE__*/ _jsx(_Fragment, {}),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "align-items-center mt-3",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex gap-2",
                                style: {
                                    flexDirection: isMobile ? "column" : "row",
                                    justifyContent: "flex-end"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: isMobile ? "" : "ms-auto",
                                        children: /*#__PURE__*/ _jsx("input", {
                                            type: "text",
                                            className: "form-control form-st-1 mb-2",
                                            placeholder: "ค้นหารายการสินค้า",
                                            style: {
                                                minWidth: isMobile ? "100%" : 170,
                                                height: 40
                                            },
                                            value: filterText,
                                            onChange: function(e) {
                                                setFilterText(e.target.value);
                                            },
                                            onKeyDown: function(e) {
                                                if (e.key === "Enter") {
                                                    setAppliedFilterText(filterText.trim());
                                                    resetCatalogPagingToTop();
                                                    setBookIdChk(0);
                                                }
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            className: "btn-dg px-2 py-2 mb-2 ".concat(isMobile ? "w-100" : "bt-width-120 w-[120px]"),
                                            onClick: function() {
                                                setAppliedFilterText(filterText.trim());
                                                resetCatalogPagingToTop();
                                                setBookIdChk(0);
                                            },
                                            variant: "",
                                            children: "ค้นหา"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "text-muted fs-12 ".concat(isMobile ? "text-start" : "text-end"),
                                children: [
                                    "แสดง ",
                                    tabledata.length,
                                    " / ",
                                    catalogTotal,
                                    " รายการ"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "my-3",
                        children: isMobile ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                tabledata && tabledata.length > 0 ? tabledata.map(function(item, index) {
                                    return /*#__PURE__*/ _jsx(Card, {
                                        className: "card-st-1 mb-4",
                                        children: /*#__PURE__*/ _jsx(CardBody, {
                                            children: /*#__PURE__*/ _jsxs(Row, {
                                                className: "align-items-start",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Col, {
                                                        xs: 12,
                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                            className: "relative overflow-hidden",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "absolute top-2 left-2 bg-red-500 text-white text-xs px-2 py-1 rounded-lg shadow",
                                                                    children: index + 1
                                                                }),
                                                                item.cl_catalog_image && item.cl_catalog_image != "" && item.cl_catalog_image != null ? /*#__PURE__*/ _jsx(Image, {
                                                                    src: item.cl_catalog_image,
                                                                    alt: item.cl_catalog_name,
                                                                    className: "w-full h-40 object-contain bg-white"
                                                                }) : /*#__PURE__*/ _jsx("div", {
                                                                    style: {
                                                                        alignContent: "center",
                                                                        border: "1px dashed rgba(203, 208, 220, 1)",
                                                                        borderRadius: 10,
                                                                        height: 160,
                                                                        width: "100%"
                                                                    }
                                                                })
                                                            ]
                                                        }, index)
                                                    }),
                                                    /*#__PURE__*/ _jsx(Col, {
                                                        xs: 12,
                                                        className: "mt-2",
                                                        children: /*#__PURE__*/ _jsx(Row, {
                                                            style: {
                                                                alignItems: "left"
                                                            },
                                                            children: /*#__PURE__*/ _jsx(CatalogNameDisplay, {
                                                                item: item,
                                                                maxWidth: 400
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx(Col, {
                                                        xs: 12,
                                                        className: "mt-1",
                                                        children: item.ClDetail.map(function(b, i) /*#__PURE__*/ {
                                                            var _b_set_unit_name, _b_cl_detail_amount;
                                                            return _jsxs(Row, {
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Col, {
                                                                        xs: 12,
                                                                        className: "my-1",
                                                                        style: {
                                                                            border: "1px solid #ccc"
                                                                        }
                                                                    }, i),
                                                                    /*#__PURE__*/ _jsx(Col, {
                                                                        xs: 4,
                                                                        sm: 3,
                                                                        md: 3,
                                                                        className: "d-flex justify-content-start align-items-center fs-12 pr-1",
                                                                        children: /*#__PURE__*/ _jsx("span", {
                                                                            style: {
                                                                                fontWeight: "bold"
                                                                            },
                                                                            children: b.cl_detail_barcode
                                                                        })
                                                                    }, i),
                                                                    /*#__PURE__*/ _jsxs(Col, {
                                                                        xs: 5,
                                                                        sm: 6,
                                                                        md: 6,
                                                                        className: "d-flex flex-wrap justify-content-start align-items-center fs-12 px-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                children: " ".concat((_b_set_unit_name = b.set_unit_name) !== null && _b_set_unit_name !== void 0 ? _b_set_unit_name : "หน่วย")
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "ml-1",
                                                                                children: "="
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "ml-1",
                                                                                children: b.cl_detail_ratio && b.cl_detail_ratio > 0 ? " ".concat(b.cl_detail_ratio) : ""
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "ml-1",
                                                                                children: b.cl_detail_ratio && b.cl_detail_ratio > 0 ? "ชิ้น" : ""
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "ml-1",
                                                                                children: b.cl_detail_ratiooption && b.cl_detail_ratiooption > 0 ? "/ ".concat(b.cl_detail_ratiooption, " แพ็ค") : ""
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "badge ms-1 ".concat(b.effective_price_source === "SPECIAL" ? "bg-warning text-dark" : "bg-light text-secondary"),
                                                                                children: b.effective_price_source === "SPECIAL" ? "ราคาพิเศษ" : "Level ".concat(b.effective_price_level || 1)
                                                                            })
                                                                        ]
                                                                    }, i),
                                                                    /*#__PURE__*/ _jsx(Col, {
                                                                        xs: 3,
                                                                        sm: 3,
                                                                        md: 3,
                                                                        className: "d-flex justify-content-end align-items-center fs-12 pl-1",
                                                                        children: /*#__PURE__*/ _jsx("span", {
                                                                            style: {
                                                                                fontWeight: "bold"
                                                                            },
                                                                            children: NumberFormat(b.cl_detail_price, 2)
                                                                        })
                                                                    }, i),
                                                                    /*#__PURE__*/ _jsx(Col, {
                                                                        xs: 4,
                                                                        className: "d-flex justify-content-start align-items-center fs-12 pr-1",
                                                                        style: {
                                                                            height: 50
                                                                        },
                                                                        children: b.cl_detail_wholesaledis ? /*#__PURE__*/ _jsxs("span", {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "flex justify-between",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            children: "Ex VAT : "
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "text-red-600",
                                                                                            children: NumberFormat(b.cl_detail_wholesaledis ? b.cl_detail_wholesaledis : 0, 2)
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "flex justify-between",
                                                                                    children: [
                                                                                        b.cl_detail_discount ? /*#__PURE__*/ _jsxs("span", {
                                                                                            className: "!bg-[#e68e99] text-white px-2",
                                                                                            children: [
                                                                                                b.cl_detail_discount,
                                                                                                item.SetPromotion.set_promotion_type == 1 ? "฿" : "%"
                                                                                            ]
                                                                                        }) : /*#__PURE__*/ _jsx("span", {}),
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "line-through text-gray-400",
                                                                                            children: NumberFormat(b.cl_detail_wholesale ? b.cl_detail_wholesale : 0, 2)
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ _jsxs("div", {
                                                                            className: "flex justify-between",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    children: "Ex VAT : "
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    children: NumberFormat(b.cl_detail_wholesale, 2)
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, i),
                                                                    /*#__PURE__*/ _jsx(Col, {
                                                                        xs: 4,
                                                                        className: "d-flex justify-content-start align-items-center fs-12 px-1",
                                                                        style: {
                                                                            height: 50
                                                                        },
                                                                        children: b.cl_detail_wholesalevatdis ? /*#__PURE__*/ _jsxs("span", {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "flex justify-between",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            children: "In VAT : "
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "text-red-600",
                                                                                            children: NumberFormat(b.cl_detail_wholesalevatdis ? b.cl_detail_wholesalevatdis : 0, 2)
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "flex justify-between",
                                                                                    children: [
                                                                                        b.cl_detail_discount ? /*#__PURE__*/ _jsxs("span", {
                                                                                            className: "!bg-[#74bfeb] text-white px-2",
                                                                                            children: [
                                                                                                b.cl_detail_discount,
                                                                                                item.SetPromotion.set_promotion_type == 1 ? "฿" : "%"
                                                                                            ]
                                                                                        }) : /*#__PURE__*/ _jsx("span", {}),
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "line-through text-gray-400",
                                                                                            children: NumberFormat(b.cl_detail_wholesalevat ? b.cl_detail_wholesalevat : 0, 2)
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ _jsxs("div", {
                                                                            className: "flex justify-between",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    children: "In VAT : "
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    children: NumberFormat(b.cl_detail_wholesalevat, 2)
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, i),
                                                                    /*#__PURE__*/ _jsx(Col, {
                                                                        xs: 4,
                                                                        className: "d-flex justify-content-center align-items-center fs-12 pl-1",
                                                                        style: {
                                                                            height: 50
                                                                        },
                                                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            inputMode: "numeric",
                                                                            pattern: "[0-9]*",
                                                                            value: (_b_cl_detail_amount = b.cl_detail_amount) !== null && _b_cl_detail_amount !== void 0 ? _b_cl_detail_amount : null,
                                                                            placeholder: "0",
                                                                            className: "fs-12",
                                                                            style: {
                                                                                width: "100%",
                                                                                textAlign: "center"
                                                                            },
                                                                            onChange: function(e) {
                                                                                handleQtyChangeCatalog(b.cl_detail_clid, b.cl_detail_id, e.target.value);
                                                                            }
                                                                        })
                                                                    }, i)
                                                                ]
                                                            }, i);
                                                        })
                                                    }),
                                                    item.SetPromotion && /*#__PURE__*/ _jsx(Col, {
                                                        xs: 12,
                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                            className: "bg-blue-50 p-2 rounded-lg text-center text-xs text-blue-600",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "font-medium",
                                                                    children: item.SetPromotion.set_promotion_name
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    children: moment(item.SetPromotion.set_promotion_sdate).format("DD/MM/YYYY") + " - " + moment(item.SetPromotion.set_promotion_edate).format("DD/MM/YYYY")
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx(Col, {
                                                        xs: 12,
                                                        className: "mt-1 text-center",
                                                        children: /*#__PURE__*/ _jsx(ButtonMui, {
                                                            variant: "contained",
                                                            color: "error",
                                                            startIcon: /*#__PURE__*/ _jsx(ShoppingCartIcon, {}),
                                                            onClick: function() {
                                                                return handleAddToCart(item.cl_catalog_id);
                                                            },
                                                            fullWidth: true,
                                                            children: "เพิ่มลงในตะกร้า"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }, index);
                                }) : /*#__PURE__*/ _jsx(Card, {
                                    className: "card-st-1 mb-4",
                                    children: /*#__PURE__*/ _jsx(CardBody, {
                                        children: /*#__PURE__*/ _jsx(Row, {
                                            className: "align-items-center",
                                            children: /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                className: "text-center py-4",
                                                children: "ไม่พบข้อมูล"
                                            })
                                        })
                                    })
                                }),
                                isCatalogLoadingMore ? /*#__PURE__*/ _jsx("div", {
                                    className: "text-center py-3",
                                    children: /*#__PURE__*/ _jsx(Spinner, {
                                        animation: "border",
                                        size: "sm"
                                    })
                                }) : null
                            ]
                        }) : /*#__PURE__*/ _jsxs("div", {
                            ref: catalogListScrollRef,
                            onScroll: handleCatalogScroll,
                            style: {
                                height: "calc(100vh - 310px)",
                                overflowX: "auto",
                                overflowY: "scroll"
                            },
                            className: "table-scroll-x-rstm",
                            children: [
                                /*#__PURE__*/ _jsxs("table", {
                                    className: "product-table-rstm",
                                    children: [
                                        /*#__PURE__*/ _jsxs("thead", {
                                            children: [
                                                /*#__PURE__*/ _jsxs("tr", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("th", {
                                                            rowSpan: 2,
                                                            children: "ลำดับ"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            rowSpan: 2,
                                                            children: "รูปสินค้า"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            rowSpan: 2,
                                                            style: {
                                                                width: 400,
                                                                maxWidth: 400
                                                            },
                                                            children: "ชื่อสินค้า"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            rowSpan: 2,
                                                            children: "Barcode"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            rowSpan: 2,
                                                            children: "ขนาดบรรจุ"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            rowSpan: 2,
                                                            children: "ราคาแนะนำขาย"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            colSpan: 2,
                                                            children: "ราคาขายส่ง"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            rowSpan: 2,
                                                            children: "โปรโมชัน"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            rowSpan: 2
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            rowSpan: 2
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("tr", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "Ex Vat"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "In Vat"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("tbody", {
                                            children: tabledata && tabledata.length > 0 ? tabledata.map(function(item, index) {
                                                return /*#__PURE__*/ _jsxs("tr", {
                                                    style: {
                                                        borderBottom: "1px solid #d2d2d2"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx(Row, {
                                                                className: "align-items-center",
                                                                children: /*#__PURE__*/ _jsx(Col, {
                                                                    xs: "auto",
                                                                    children: index + 1
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx(Row, {
                                                                className: "align-items-center",
                                                                children: /*#__PURE__*/ _jsx(Col, {
                                                                    xs: "auto",
                                                                    children: /*#__PURE__*/ _jsx("img", {
                                                                        src: item.cl_catalog_image,
                                                                        alt: item.cl_catalog_name,
                                                                        style: {
                                                                            maxWidth: 80,
                                                                            maxHeight: 80
                                                                        }
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            style: {
                                                                width: 400,
                                                                maxWidth: 400
                                                            },
                                                            children: /*#__PURE__*/ _jsx(Row, {
                                                                className: "align-items-center",
                                                                children: /*#__PURE__*/ _jsx(CatalogNameDisplay, {
                                                                    item: item,
                                                                    maxWidth: 400
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx(Row, {
                                                                children: item.ClDetail.map(function(b, i) {
                                                                    return /*#__PURE__*/ _jsx(Col, {
                                                                        xs: 12,
                                                                        className: "d-flex justify-content-center align-items-center",
                                                                        style: {
                                                                            height: 50
                                                                        },
                                                                        children: /*#__PURE__*/ _jsx("span", {
                                                                            children: b.cl_detail_barcode
                                                                        })
                                                                    }, i);
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx(Row, {
                                                                children: item.ClDetail.map(function(b, i) /*#__PURE__*/ {
                                                                    var _b_set_unit_name;
                                                                    return _jsxs(Col, {
                                                                        xs: 12,
                                                                        className: "d-flex justify-content-start align-items-center",
                                                                        style: {
                                                                            height: 50
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                style: {
                                                                                    float: "left",
                                                                                    width: "40px"
                                                                                },
                                                                                children: " ".concat((_b_set_unit_name = b.set_unit_name) !== null && _b_set_unit_name !== void 0 ? _b_set_unit_name : "หน่วย")
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                children: "="
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "!bg-[#d9d9ded9] pl-2 pr-3 pt-2 pb-2 ml-2",
                                                                                style: {
                                                                                    borderRadius: 5
                                                                                },
                                                                                children: b.cl_detail_ratio && b.cl_detail_ratio > 0 ? " ".concat(b.cl_detail_ratio) : ""
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "ml-2",
                                                                                children: b.cl_detail_ratio && b.cl_detail_ratio > 0 ? "ชิ้น" : ""
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "ml-2",
                                                                                children: b.cl_detail_ratiooption && b.cl_detail_ratiooption > 0 ? "/ ".concat(b.cl_detail_ratiooption, " แพ็ค") : ""
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "badge ms-2 ".concat(b.effective_price_source === "SPECIAL" ? "bg-warning text-dark" : "bg-light text-secondary"),
                                                                                children: b.effective_price_source === "SPECIAL" ? "ราคาพิเศษ" : "Level ".concat(b.effective_price_level || 1)
                                                                            })
                                                                        ]
                                                                    }, i);
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx(Row, {
                                                                children: item.ClDetail.map(function(b, i) {
                                                                    return /*#__PURE__*/ _jsx(Col, {
                                                                        xs: 12,
                                                                        className: "d-flex justify-content-end align-items-center",
                                                                        style: {
                                                                            height: 50
                                                                        },
                                                                        children: /*#__PURE__*/ _jsx("span", {
                                                                            children: NumberFormat(b.cl_detail_price, 2)
                                                                        })
                                                                    }, i);
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx(Row, {
                                                                children: item.ClDetail.map(function(b, i) /*#__PURE__*/ {
                                                                    var _b_cl_detail_wholesale;
                                                                    return _jsx(Col, {
                                                                        xs: 12,
                                                                        className: "d-flex justify-content-end align-items-center",
                                                                        style: {
                                                                            height: 50
                                                                        },
                                                                        children: /*#__PURE__*/ _jsxs(StackMui, {
                                                                            direction: "row",
                                                                            justifyContent: "space-between",
                                                                            alignContent: "flex-start",
                                                                            alignItems: "flex-start",
                                                                            sx: b.cl_detail_discount && b.cl_detail_discount > 0 ? {
                                                                                mt: "26px"
                                                                            } : {},
                                                                            children: [
                                                                                b.cl_detail_discount ? /*#__PURE__*/ _jsxs("div", {
                                                                                    class: "price-tag",
                                                                                    style: {
                                                                                        color: "#ffffff"
                                                                                    },
                                                                                    children: [
                                                                                        b.cl_detail_discount,
                                                                                        item.SetPromotion.set_promotion_type == 1 ? "฿" : "%"
                                                                                    ]
                                                                                }) : /*#__PURE__*/ _jsx("div", {}),
                                                                                /*#__PURE__*/ _jsx(StackMui, {
                                                                                    direction: "column",
                                                                                    justifyContent: "flex-end",
                                                                                    alignContent: "flex-end",
                                                                                    alignItems: "flex-end",
                                                                                    children: b.cl_detail_wholesaledis ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                                style: {
                                                                                                    color: "#b00312"
                                                                                                },
                                                                                                children: NumberFormat(b.cl_detail_wholesaledis ? b.cl_detail_wholesaledis : 0, 2)
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                                class: "old-price",
                                                                                                children: NumberFormat(b.cl_detail_wholesale ? b.cl_detail_wholesale : 0, 2)
                                                                                            })
                                                                                        ]
                                                                                    }) : /*#__PURE__*/ _jsx("span", {
                                                                                        style: {
                                                                                            color: "#212529"
                                                                                        },
                                                                                        children: NumberFormat((_b_cl_detail_wholesale = b.cl_detail_wholesale) !== null && _b_cl_detail_wholesale !== void 0 ? _b_cl_detail_wholesale : 0, 2)
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, i);
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx(Row, {
                                                                children: item.ClDetail.map(function(b, i) /*#__PURE__*/ {
                                                                    var _b_cl_detail_wholesalevat;
                                                                    return _jsx(Col, {
                                                                        xs: 12,
                                                                        className: "d-flex justify-content-end align-items-center",
                                                                        style: {
                                                                            height: 50
                                                                        },
                                                                        children: /*#__PURE__*/ _jsxs(StackMui, {
                                                                            direction: "row",
                                                                            justifyContent: "space-between",
                                                                            alignContent: "flex-start",
                                                                            alignItems: "flex-start",
                                                                            sx: b.cl_detail_discount && b.cl_detail_discount > 0 ? {
                                                                                mt: "26px"
                                                                            } : {},
                                                                            children: [
                                                                                b.cl_detail_discount ? /*#__PURE__*/ _jsxs("div", {
                                                                                    class: "discount-tag",
                                                                                    style: {
                                                                                        color: "#ffffff"
                                                                                    },
                                                                                    children: [
                                                                                        b.cl_detail_discount,
                                                                                        item.SetPromotion.set_promotion_type == 1 ? "฿" : "%"
                                                                                    ]
                                                                                }) : /*#__PURE__*/ _jsx("div", {}),
                                                                                /*#__PURE__*/ _jsx(StackMui, {
                                                                                    direction: "column",
                                                                                    justifyContent: "flex-end",
                                                                                    alignContent: "flex-end",
                                                                                    alignItems: "flex-end",
                                                                                    children: b.cl_detail_wholesalevatdis ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                                style: {
                                                                                                    color: "#b00312"
                                                                                                },
                                                                                                children: NumberFormat(b.cl_detail_wholesalevatdis ? b.cl_detail_wholesalevatdis : 0, 2)
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                                class: "old-price",
                                                                                                children: NumberFormat(b.cl_detail_wholesalevat ? b.cl_detail_wholesalevat : 0, 2)
                                                                                            })
                                                                                        ]
                                                                                    }) : /*#__PURE__*/ _jsx("span", {
                                                                                        style: {
                                                                                            color: "#212529"
                                                                                        },
                                                                                        children: NumberFormat((_b_cl_detail_wholesalevat = b.cl_detail_wholesalevat) !== null && _b_cl_detail_wholesalevat !== void 0 ? _b_cl_detail_wholesalevat : 0, 2)
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, i);
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx(Row, {
                                                                className: "align-items-center",
                                                                children: /*#__PURE__*/ _jsx(Col, {
                                                                    xs: "auto",
                                                                    children: item.SetPromotion ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "mb-[10px] text-center",
                                                                                children: item.SetPromotion.set_promotion_name
                                                                            }),
                                                                            item.SetPromotion.set_promotion_type == 3 && /*#__PURE__*/ _jsx("div", {
                                                                                className: "mb-[10px] text-center",
                                                                                children: item.SetPromotion.set_promotion_buy && item.SetPromotion.set_promotion_free && /*#__PURE__*/ _jsxs(StackMui, {
                                                                                    direction: "row",
                                                                                    justifyContent: "space-between",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "pt-2 ml-10",
                                                                                            children: /*#__PURE__*/ _jsxs("span", {
                                                                                                className: "!bg-[#0012fd] text-white px-2 py-1 fs-12",
                                                                                                style: {
                                                                                                    borderRadius: 10
                                                                                                },
                                                                                                children: [
                                                                                                    item.SetPromotion.set_promotion_buy ? "".concat(item.SetPromotion.set_promotion_buy, " +") : "",
                                                                                                    item.SetPromotion.set_promotion_free ? "".concat(item.SetPromotion.set_promotion_free) : ""
                                                                                                ]
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "fs-14",
                                                                                            style: {
                                                                                                color: "#0012fd"
                                                                                            },
                                                                                            children: item.ClDetail.map(function(ele, i) {
                                                                                                return /*#__PURE__*/ _jsx("span", {
                                                                                                    children: ele.cl_detail_wholesaleavg ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ _jsx("p", {
                                                                                                                children: "เฉลี่ยแพ็คละ"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ _jsx("p", {
                                                                                                                children: ele.cl_detail_wholesaleavg
                                                                                                            })
                                                                                                        ]
                                                                                                    }) : ""
                                                                                                }, i);
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsxs("div", {
                                                                                className: "mb-[10px] text-center",
                                                                                children: [
                                                                                    moment(item.SetPromotion.set_promotion_sdate).format("DD/MM/YYYY"),
                                                                                    " ",
                                                                                    "-",
                                                                                    " ",
                                                                                    moment(item.SetPromotion.set_promotion_edate).format("DD/MM/YYYY")
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }) : /*#__PURE__*/ _jsx("div", {
                                                                        className: "text-center",
                                                                        children: "-"
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx(Row, {
                                                                children: item.ClDetail.map(function(b, i) /*#__PURE__*/ {
                                                                    var _b_cl_detail_amount;
                                                                    return _jsx(Col, {
                                                                        xs: 12,
                                                                        className: "d-flex justify-content-center align-items-center",
                                                                        style: {
                                                                            height: 50
                                                                        },
                                                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            inputMode: "numeric",
                                                                            pattern: "[0-9]*",
                                                                            value: (_b_cl_detail_amount = b.cl_detail_amount) !== null && _b_cl_detail_amount !== void 0 ? _b_cl_detail_amount : null,
                                                                            placeholder: "0",
                                                                            style: {
                                                                                width: 100,
                                                                                textAlign: "center"
                                                                            },
                                                                            onChange: function(e) {
                                                                                handleQtyChangeCatalog(b.cl_detail_clid, b.cl_detail_id, e.target.value);
                                                                            }
                                                                        })
                                                                    }, i);
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx(ButtonMui, {
                                                                variant: "outlined",
                                                                color: "error",
                                                                startIcon: /*#__PURE__*/ _jsx(ShoppingCartIcon, {}),
                                                                onClick: function() {
                                                                    return handleAddToCart(item.cl_catalog_id);
                                                                },
                                                                style: {
                                                                    color: "#FF4F4F",
                                                                    borderColor: "#FF4F4F",
                                                                    borderRadius: 20
                                                                },
                                                                children: "เพิ่มลงในตะกร้า"
                                                            })
                                                        })
                                                    ]
                                                }, index);
                                            }) : /*#__PURE__*/ _jsx("tr", {
                                                children: /*#__PURE__*/ _jsx("td", {
                                                    colSpan: 10,
                                                    className: "text-center",
                                                    children: "ไม่มีข้อมูล"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                isCatalogLoadingMore ? /*#__PURE__*/ _jsx("div", {
                                    className: "text-center py-3",
                                    children: /*#__PURE__*/ _jsx(Spinner, {
                                        animation: "border",
                                        size: "sm"
                                    })
                                }) : null
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Modal.Footer, {
                children: /*#__PURE__*/ _jsx(Button, {
                    variant: "outline-secondary",
                    onClick: handleClose,
                    children: "ปิด"
                })
            })
        ]
    }));
}
function SaveDataModal(_param) {
    var dataFrom = _param.dataFrom, setDataFrom = _param.setDataFrom, props = _object_without_properties(_param, [
        "dataFrom",
        "setDataFrom"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var reportId = useParams().reportId;
    var reserveStatus = Number(props.reserveStatus);
    var reserveData = props.reserveData || {};
    var reservationListPath = props.reservationListPath || "/report/reservation";
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var updateRsreserveReducer = useAppSelector(function(state) {
        return state.updateRsreserveReducer;
    });
    var updateRsreserveStockReducer = useAppSelector(function(state) {
        return state.updateRsreserveStockReducer;
    });
    var handleChange = function(e) {};
    var parseNumberOrZero = function(value) {
        var parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : 0;
    };
    var handleClick = function(val) {
        var hasDetailChanges = Array.isArray(dataFrom) && dataFrom.length > 0;
        var canSubmitRemark = reserveStatus === 1;
        var canSubmitSchedule = reserveStatus === 4;
        if (reserveStatus === 4 && (!reserveData.rs_reserve_dateorganize || !reserveData.rs_reserve_datedelivery)) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 400",
                navigateDirection: undefined,
                title: "กรุณากรอก วันที่จัดสินค้า และ วันที่คาดว่าจะจัดส่งสินค้า"
            }));
            props.onHide();
            return;
        }
        if (hasDetailChanges || canSubmitRemark || canSubmitSchedule) {
            setIsLoading(true);
            var payload = {};
            if (reportId && reportId != "" && reportId != null) {
                if (reserveStatus === 1) {
                    var shippingPayType = Number(reserveData.rs_reserve_shipping_paytype);
                    var _reserveData_rs_reserve_remark, _reserveData_rs_reserve_note, _reserveData_rs_reserve_credit;
                    payload = _object_spread_props(_object_spread({
                        rs_reserve_id: parseInt(reportId, 10),
                        rs_reserve_remark: (_reserveData_rs_reserve_remark = reserveData.rs_reserve_remark) !== null && _reserveData_rs_reserve_remark !== void 0 ? _reserveData_rs_reserve_remark : "",
                        rs_reserve_note: (_reserveData_rs_reserve_note = reserveData.rs_reserve_note) !== null && _reserveData_rs_reserve_note !== void 0 ? _reserveData_rs_reserve_note : "",
                        rs_reserve_credit: (_reserveData_rs_reserve_credit = reserveData.rs_reserve_credit) !== null && _reserveData_rs_reserve_credit !== void 0 ? _reserveData_rs_reserve_credit : "",
                        rs_reserve_discounttype: reserveData.rs_reserve_discounttype === 0 || reserveData.rs_reserve_discounttype === "0" ? 0 : Number(reserveData.rs_reserve_discounttype) === 2 ? 2 : 1,
                        rs_reserve_discount: reserveData.rs_reserve_discounttype === 0 || reserveData.rs_reserve_discounttype === "0" ? 0 : parseNumberOrZero(reserveData.rs_reserve_discount),
                        rs_reserve_discountreal: reserveData.rs_reserve_discounttype === 0 || reserveData.rs_reserve_discounttype === "0" ? 0 : parseNumberOrZero(reserveData.rs_reserve_discountreal),
                        rs_reserve_price: parseNumberOrZero(reserveData.rs_reserve_price)
                    }, [
                        1,
                        2
                    ].includes(shippingPayType) && {
                        rs_reserve_shipping_paytype: shippingPayType
                    }), {
                        rsDetail: hasDetailChanges ? dataFrom.map(function(item) {
                            return {
                                rs_detail_id: parseInt(item.rs_detail_id, 10),
                                rs_detail_amount: parseInt(item.rs_detail_amount, 10),
                                rs_detail_stamount: parseNumberOrZero(item.rs_detail_stamount),
                                rs_detail_wholesale: parseNumberOrZero(item.rs_detail_wholesale),
                                rs_catalog_free: Number(item.rs_catalog_free) === 2 ? 2 : 1,
                                rs_catalog_tester: Number(item.rs_catalog_tester) === 2 ? 2 : 1,
                                rs_catalog_remark: item.rs_catalog_remark || ""
                            };
                        }) : []
                    });
                    dispatch(updateRsreserve(payload, {
                        modalObj: modalObj,
                        setModalObj: setModalObj
                    }));
                }
                if (reserveStatus === 4) {
                    var data = {
                        rs_reserve_id: parseInt(reportId),
                        rs_reserve_dateorganize: reserveData.rs_reserve_dateorganize || null,
                        rs_reserve_datedelivery: reserveData.rs_reserve_datedelivery || null,
                        rs_reserve_discounttype: reserveData.rs_reserve_discounttype === 0 || reserveData.rs_reserve_discounttype === "0" ? 0 : Number(reserveData.rs_reserve_discounttype) === 2 ? 2 : 1,
                        rs_reserve_discount: reserveData.rs_reserve_discounttype === 0 || reserveData.rs_reserve_discounttype === "0" ? 0 : parseNumberOrZero(reserveData.rs_reserve_discount),
                        rs_reserve_discountreal: reserveData.rs_reserve_discounttype === 0 || reserveData.rs_reserve_discounttype === "0" ? 0 : parseNumberOrZero(reserveData.rs_reserve_discountreal),
                        rs_reserve_stprice: parseNumberOrZero(reserveData.rs_reserve_stprice),
                        rsDetail: hasDetailChanges ? dataFrom.map(function(item) {
                            return {
                                rs_detail_id: parseInt(item.rs_detail_id, 10),
                                rs_detail_stamount: parseNumberOrZero(item.rs_detail_stamount),
                                rs_catalog_free: Number(item.rs_catalog_free) === 2 ? 2 : 1,
                                rs_catalog_tester: Number(item.rs_catalog_tester) === 2 ? 2 : 1,
                                rs_catalog_remark: item.rs_catalog_remark || ""
                            };
                        }) : []
                    };
                    dispatch(updateRsreserveStock(data, {
                        modalObj: modalObj,
                        setModalObj: setModalObj
                    }));
                }
            }
            setIsBoxAlert(true);
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateRsreserveReducer.isFetching || updateRsreserveStockReducer.isFetching);
        if (reportId && reportId != "" && reportId != null) {
            if (updateRsreserveReducer.data && !updateRsreserveReducer.isError) {
                var updatedData = updateRsreserveReducer.data.data;
                dispatch(clearUpdateRsreserve());
                if (isBoxAlert) {
                    props.setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: true,
                            textsuccess: "บันทึกเรียบร้อย",
                            direction: reservationListPath
                        });
                    });
                    setIsBoxAlert(false);
                }
            }
            if (updateRsreserveStockReducer.data && !updateRsreserveStockReducer.isError) {
                dispatch(clearupdateRsreserveStock());
                if (isBoxAlert) {
                    props.setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: true,
                            textsuccess: "บันทึกเรียบร้อย",
                            direction: reservationListPath
                        });
                    });
                    setIsBoxAlert(false);
                }
            }
        }
    }, [
        updateRsreserveReducer,
        updateRsreserveStockReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "บันทึกข้อมูล"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsxs(Badge, {
                    bg: "danger-light",
                    text: "dark",
                    children: [
                        /*#__PURE__*/ _jsx(InfoIcon, {
                            sx: {
                                color: "#B00412"
                            },
                            className: "mr-2"
                        }),
                        "คุณต้องการที่จะบันทึกข้อมูลการจองนี้หรือไม่"
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function DeleteDataModal(_param) {
    var rsCatalogId = _param.rsCatalogId, props = _object_without_properties(_param, [
        "rsCatalogId"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var reportId = useParams().reportId;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var deleteRsreserveReducer = useAppSelector(function(state) {
        return state.deleteRsreserveReducer;
    });
    var handleChange = function(e) {};
    var handleClick = function(val) {
        if (rsCatalogId && rsCatalogId != "" && rsCatalogId != null) {
            setIsLoading(true);
            var payload = {};
            if (reportId && reportId != "" && reportId != null) {
                payload = {
                    rscatalogid: parseInt(rsCatalogId, 10)
                };
                dispatch(deleteRsreserve(payload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
            setIsBoxAlert(true);
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(deleteRsreserveReducer.isFetching);
        if (reportId && reportId != "" && reportId != null) {
            if (deleteRsreserveReducer.data && !deleteRsreserveReducer.isError) {
                dispatch(clearDeleteRsreserve());
                if (isBoxAlert) {
                    var _props_onDeleted;
                    props.setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: true,
                            textsuccess: "ลบข้อมูลเรียบร้อย",
                            direction: ""
                        });
                    });
                    setIsBoxAlert(false);
                    (_props_onDeleted = props.onDeleted) === null || _props_onDeleted === void 0 ? void 0 : _props_onDeleted.call(props, rsCatalogId);
                }
            }
        }
    }, [
        deleteRsreserveReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "ลบข้อมูล"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsxs(Badge, {
                    bg: "danger-light",
                    text: "dark",
                    children: [
                        /*#__PURE__*/ _jsx(InfoIcon, {
                            sx: {
                                color: "#B00412"
                            },
                            className: "mr-2"
                        }),
                        "คุณต้องการที่จะลบข้อมูลรายการนี้หรือไม่"
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
